{
  "cta": {
    "create-a-chart": "Tabelle erstellen"
  },
  "breadcrumb": {
    "dashboard": "Dashboard",
    "products": "Produkte",
    "charts": "Tabellen",
    "restock-alerts": "Nachbestell-Benachrichtigungen",
    "settings": "Einstellungen",
    "setting": "Einstellungen",
    "account": "Konto",
    "personal": "Persönlich",
    "organization": "Organisation",
    "appearance": "Erscheinungsbild",
    "themes": "Themen",
    "button": "Schaltfläche",
    "font-family": "Schriftfamilie",
    "uploads": "Uploads",
    "dimensions": "Dimensionen",
    "notifications": "Benachrichtigungen",
    "analytic": "Analyse",
    "analytics": "Analyse",
    "restock-settings": "Nachbestell-Einstellungen",
    "inventory": "Nachbestell-Benachrichtigungen",
    "plans": "Pläne",
    "billing": "Abrechnung",
    "overview": "Übersicht",
    "plan-and-usage": "Plan und Nutzung",
    "chart-views": "Tabellenansichten",
    "add-to-cart": "In den Warenkorb",
    "buy-now": "Jetzt kaufen",
    "size-recommendations": "Größenempfehlungen",
    "stock-notifications": "Lagerbenachrichtigungen",
    "reports": "Berichte",
    "comparison": "Vergleich",
    "images": "Uploads",
    "sidekick": "Sidekick",
    "import": "Import",
    "contact": "Kontakt",
    "help-articles": "Hilfeartikel",
    "new": "Neu"
  },
  "page": {
    "dashboard": {
      "table-style-chart": "Tabellenstil-Tabelle",
      "build-a-fully-custom-grid-with-complete-control-over-every-row-column-and-measurement-unit-best-for-complex-sizing-across-multiple-regions": "Erstellen Sie ein vollständig angepasstes Raster mit voller Kontrolle über jede Zeile, Spalte und Maßeinheit. Am besten für komplexe Größenangaben über mehrere Regionen hinweg.",
      "create-table-chart": "Rastertabelle erstellen",
      "create-from-product": "Aus Produkt erstellen",
      "start-from-template": "Von Vorlage starten",
      "browse-templates": "Vorlagen durchsuchen",
      "create-with-drag-drop": "Mit Drag & Drop erstellen",
      "creating": "Wird erstellt",
      "how-would-you-like-to-build-your-chart": "Wie möchten Sie<br /><span class=\"text-primary\">Ihre Tabelle erstellen?</span>",
      "choose-a-method-below-or-tell-us-what-you-sell-and-we-ll-highlight-the-best-fit": "Wählen Sie unten eine Methode aus, oder sagen Sie uns, was Sie verkaufen, und wir heben die beste Option hervor.",
      "fastest-setup-2-min": "Schnellste Einrichtung · ~2 Min.",
      "used-by-1000-merchants": "Von über 1000 Händlern genutzt",
      "auto-generate-a-matching-size-chart-directly-from-your-existing-shopify-variant-data-no-manual-entry-it-reads-your-product-and-fills-the-table-for-you": "Generieren Sie automatisch eine passende Größentabelle direkt aus Ihren vorhandenen Shopify-Variantendaten. Keine manuelle Eingabe — sie liest Ihr Produkt und füllt die Tabelle für Sie aus",
      "garment-templates-ready-to-use": "Einsatzbereite Bekleidungsvorlagen",
      "pick-from-ready-made-templates-for-tops-bottoms-shoes-belts-bags-and-more-customise-any-field-after-great-for-getting-started-in-under-a-minute": "Wählen Sie aus fertigen Vorlagen für Oberteile, Hosen, Schuhe, Gürtel, Taschen und mehr. Passen Sie danach jedes Feld an — ideal, um in unter einer Minute loszulegen.",
      "drag-drop-no-data-needed-upfront": "Drag & Drop · keine Daten im Voraus erforderlich",
      "upload-any-product-image-and-annotate-measurements-directly-on-it-with-drag-drop-pins-ideal-for-shoes-bags-accessories-and-equipment": "Laden Sie ein beliebiges Produktbild hoch und markieren Sie Maße direkt darauf mit Drag-&-Drop-Punkten. Ideal für Schuhe, Taschen, Accessoires und Ausrüstung.",
      "excel-like": "Excel-ähnlich",
      "auto-generated": "Automatisch generiert",
      "annotate-on-image": "Auf Bild markieren",
      "what-are-you-selling": "Was verkaufen Sie?",
      "category-clothing-apparel": "Kleidung & Bekleidung",
      "category-shoes": "Schuhe",
      "category-accessories": "Accessoires",
      "category-other": "Etwas anderes",
      "start-date": "Startdatum",
      "end-date": "Enddatum"
    },
    "products": {
      "select-a-product-to-create-or-link-a-size-chart-for-that-product": "Wählen Sie ein Produkt aus, um eine Größentabelle dafür zu erstellen oder zu verknüpfen.",
      "product-name": "Produktname",
      "best-selling": "Bestseller",
      "most-selling": "Meistverkaufte zuerst",
      "least-selling": "Am wenigsten verkauft",
      "best-selling-unavailable": "Verkaufsdaten sind noch nicht verfügbar, daher werden Produkte nach der letzten Aktualisierung angezeigt.",
      "chart-attached": "Tabelle angehängt",
      "shopify-status": "Shopify-Status",
      "search-placeholder": "Alle Produkte durchsuchen...",
      "vendors": "Anbieter",
      "tags": "Tags",
      "statuses": "Status",
      "collections": "Kollektionen",
      "types": "Typen",
      "add-filter": "Filter hinzufügen",
      "categories": "Kategorien",
      "search-and-filter-tooltip": "Suchen und filtern (F)",
      "import-selection": "Auswahl importieren",
      "failed-import-measurements": "Import der Maße fehlgeschlagen",
      "product-updated": "Produkt erfolgreich aktualisiert"
    },
    "charts": {
      "create-edit-duplicate-or-link-a-chart-to-a-product-from-here": "Erstellen, bearbeiten, duplizieren oder verknüpfen Sie hier eine Tabelle mit einem Produkt.",
      "chart-name": "Tabellenname",
      "chart-type": "Tabellentyp",
      "linked-to": "Verknüpft mit",
      "last-updated": "Zuletzt aktualisiert",
      "delete-x-charts": "{{ x }} Tabellen löschen",
      "assigned-products": "Zugewiesene Produkte",
      "failed-to-fetch-products-data": "Produktdaten konnten nicht abgerufen werden",
      "delete-chart": "Tabelle löschen",
      "are-you-sure-you-want-to-delete-selected-chart-s-all-products-using-chart-s-will-be-unassigned": "Möchten Sie die ausgewählte(n) Tabelle(n) wirklich löschen? Alle Produkte, die diese Tabelle(n) verwenden, werden nicht mehr zugewiesen.",
      "successfully-deleted-chart-s": "Tabelle(n) erfolgreich gelöscht!",
      "successfully-duplicated-chart": "Tabelle erfolgreich dupliziert!",
      "turn-this-into-a-conversion-chart": "In eine Konversionstabelle umwandeln",
      "upgradable-tooltip": "Diese Rastertabelle sieht aus wie eine strukturierte Größentabelle und kann konvertiert werden.",
      "convert-to-size-chart": "In Größentabelle umwandeln",
      "convertibility-failed": "Wir konnten nicht überprüfen, welche Rastertabellen konvertiert werden können.",
      "convert": {
        "table-chart-info-callout": "Diese Rastertabelle kann zu einer intelligenten Größentabelle aufgewertet werden",
        "table-chart-info-callout-message": "Die Konvertierung ordnet Ihr Raster den Dimensionen aus Ihrer Bibliothek zu und schaltet einen visuellen Maßleitfaden sowie Modellinformationen frei, die eine einfache Tabelle nicht anzeigen kann.",
        "successfully-converted": "Erfolgreich in eine Größentabelle umgewandelt!",
        "detected-sizes": "Erkannte Größen",
        "at-least-two-sizes-are-needed": "Es werden mindestens zwei Größen benötigt, um diese Tabelle zu konvertieren.",
        "unnamed-row": "Unbenannte Zeile",
        "ignore-this-row": "Diese Zeile ignorieren",
        "this-dimension-is-already-mapped": "Diese Dimension ist bereits einer anderen Zeile zugeordnet.",
        "map-at-least-one-row": "Ordnen Sie mindestens eine Zeile einer Dimension zu.",
        "finish-your-measurement-guide": "Vervollständigen Sie Ihren Maßleitfaden",
        "measurement-points-without-values": "Messpunkte ohne Werte ({{ x }})",
        "fill-them-in-after-converting": "Ihr ausgewähltes Bild zeigt sie, aber Ihre Tabelle hatte keine solchen Zeilen. Füllen Sie deren Werte nach der Konvertierung aus.",
        "measurements-without-points": "Maße ohne Punkt auf Ihrem Bild ({{ x }})",
        "no-image-selected-yet": "Noch kein Bild ausgewählt",
        "upload-an-image-then-drag-points": "Laden Sie ein Bild hoch und ziehen Sie dann die Messpunkte darauf.",
        "your-image-has-no-measurement-points": "Ihr ausgewähltes Bild hat noch keine Messpunkte",
        "drag-measurement-points-onto-the-image": "Ziehen Sie deren Messpunkte auf das Bild, damit Käufer sehen können, wo sie messen müssen.",
        "plus-x-more": "+{{ x }} weitere",
        "satisfied-button": "Sieht gut aus — dies zu meiner aktiven Tabelle machen",
        "satisfied-explanation": "Ihre Rastertabelle wird nicht mehr veröffentlicht, diese Tabelle wird veröffentlicht, und ihre zugewiesenen Produkte werden übertragen.",
        "satisfied-success": "Diese Tabelle ist jetzt aktiv!",
        "step-x-of-y": "Schritt {{ x }} von {{ y }}",
        "choose-product-type": "Produkttyp auswählen",
        "well-match-your-table-to-a-visual": "Wir ordnen Ihre Tabelle dem passenden visuellen Produkt zu.",
        "save-settings": "Einstellungen speichern",
        "review-table-mapping": "Tabellenzuordnung überprüfen",
        "confirm-the-rows-to-convert": "Bestätigen Sie die Zeilen, die wir konvertieren sollen.",
        "existing-table": "Vorhandene Tabelle",
        "sizes": "Größen",
        "row": "Zeile",
        "column": "Spalte",
        "x-rows-need-review": "{{ x }} Zeilen müssen überprüft werden",
        "couldnt-match-this-row": "Wir konnten dieses Maß nicht automatisch zuordnen",
        "change-match": "Zuordnung ändern",
        "view-values": "Werte anzeigen",
        "hide-values": "Werte ausblenden",
        "matched-automatically": "Automatisch zugeordnet",
        "edit-matches": "Zuordnungen bearbeiten",
        "create-preview": "Vorschau erstellen",
        "preview-ready": "Vorschau bereit",
        "open-it-to-finish-the-missing-values": "Öffnen Sie sie, um die fehlenden Werte zu vervollständigen.",
        "converted": "Konvertiert",
        "open-preview": "Vorschau öffnen",
        "you-can-add-them-in-the-preview": "Sie können sie in der Vorschau hinzufügen."
      }
    },
    "inventory": {
      "collect-emails-and-send-automatic-back-in-stock-notifications-setup-notification": "Sammeln Sie E-Mails und senden Sie automatische Benachrichtigungen bei Wiederverfügbarkeit. Benachrichtigung einrichten",
      "here": "hier",
      "successfully-export-inventory-data": "Lagerdaten erfolgreich exportiert",
      "active-your-store-inventory-notification-feature": "Aktivieren Sie die Lagerbenachrichtigungsfunktion Ihres Shops",
      "in-order-to-receive-users-subscribed-for-your-products": "um Benutzer zu erhalten, die Ihre Produkte abonniert haben.",
      "your-subscribers-have-been-delegeted-to-your": "Ihre Abonnenten wurden übertragen an Ihr"
    },
    "setting": {
      "storefront-popup-preview": "Vorschau des Shop-Popups",
      "add-to-cart": "In den Warenkorb",
      "buy-now": "Jetzt kaufen",
      "sans-serif": "Serifenlos",
      "serif": "Serifenschrift",
      "email-body-is-required": "E-Mail-Text ist erforderlich",
      "list": "Liste",
      "category-image": "Kategoriebild",
      "pay-over-usage-cost": "Übernutzungskosten bezahlen",
      "over-usage-count": "Übernutzungsanzahl",
      "over-usage-cost": "Übernutzungskosten",
      "x-usages": "{{ x }} Nutzungen",
      "failed-to-pay-over-usage-cost": "Übernutzungskosten konnten nicht bezahlt werden",
      "manage-your-personal-information-and-account-perferences": "Verwalten Sie Ihre persönlichen Daten und Kontopräferenzen.",
      "manage-your-organization-contact-information-and-address": "Verwalten Sie die Kontaktinformationen und Adresse Ihrer Organisation.",
      "manage-your-billing-overview": "Überprüfen Sie Ihre Abrechnungsdetails, Plan und Zahlungsinformationen.",
      "manage-your-plan-and-usage": "Sehen Sie Ihren aktuellen Plan und Nutzungslimits ein.",
      "manage-your-measurement-dimensions": "Verwalten Sie die Maßdimensionen, die in Ihren Größentabellen verwendet werden.",
      "dimension-translations": "Shop-Übersetzungen",
      "dimension-translations-description": "Geben Sie die Bezeichnung ein, die Käufer für jede unterstützte Shop-Sprache sehen sollen. Leer lassen, um den Standardnamen zu verwenden.",
      "default-dimension-name": "Standard-Dimensionsname",
      "dimension-name-description": "Wird im gesamten Dashboard und als Shop-Fallback verwendet, wenn keine Übersetzung angegeben ist.",
      "storefront-label": "Shop-Bezeichnung",
      "naming": "Benennung",
      "affecting-data": "Betroffene Daten",
      "first-name-is-required": "Vorname ist erforderlich",
      "last-name-is-required": "Nachname ist erforderlich",
      "subscribed-for-our-latest-news-exclusive-offers-and-exciting-updates": "Abonniert für unsere neuesten Nachrichten, exklusiven Angebote und spannenden Updates.",
      "contact-information": "Kontaktinformationen",
      "contact-name": "Kontaktname",
      "contact-name-is-required": "Kontaktname ist erforderlich!",
      "contact-email": "Kontakt-E-Mail",
      "contact-email-is-required": "Kontakt-E-Mail ist erforderlich!",
      "contact-email-is-invalid": "Kontakt-E-Mail ist ungültig!",
      "company-organization-name": "Firmen-/Organisationsname",
      "company-organization-name-is-required": "Firmen-/Organisationsname ist erforderlich",
      "street-address": "Straße",
      "street-address-is-required": "Straße ist erforderlich!",
      "street-address-2": "Adresszusatz",
      "city": "Stadt",
      "city-is-required": "Stadt ist erforderlich!",
      "state-province-region": "Bundesland/Provinz/Region",
      "state-province-region-is-required": "Bundesland/Provinz/Region ist erforderlich!",
      "country": "Land",
      "country-is-required": "Land ist erforderlich!",
      "postal-zip-code": "Postleitzahl",
      "postal-zip-code-is-required": "Postleitzahl ist erforderlich!",
      "themes": "Themen",
      "customise-your-app-look-choose-a-colour-that-best-represents-your-brand": "Passen Sie das Aussehen Ihrer App an! Wählen Sie eine Farbe, die Ihre Marke am besten repräsentiert",
      "sunset-ember": "Sonnenuntergangsglut",
      "classic-noir": "Klassisches Schwarz",
      "system-background-colour": "System-Hintergrundfarbe",
      "customise-your-button": "Passen Sie Ihre Schaltfläche an",
      "customise-your-button-text-colour-and-style-to-match-your-brand": "Passen Sie Text, Farbe und Stil Ihrer Schaltfläche an Ihre Marke an.",
      "what-should-the-button-say": "Was soll auf der Schaltfläche stehen?",
      "label-button-is-required": "Schaltflächenbeschriftung ist erforderlich!",
      "text-colour": "Textfarbe",
      "text-colour-is-required": "Textfarbe ist erforderlich!",
      "please-input-valid-hex-color-code": "Bitte geben Sie einen gültigen Hex-Farbcode ein",
      "background-color": "Hintergrundfarbe",
      "background-colour-is-required": "Hintergrundfarbe ist erforderlich!",
      "font-size-in-px": "Schriftgröße in px",
      "font-size-in-px-is-required": "Schriftgröße in px ist erforderlich!",
      "border-radius": "Randradius",
      "border-radius-is-required": "Randradius ist erforderlich!",
      "successfully-updated-button-style": "Schaltflächenstil erfolgreich aktualisiert",
      "font-family": "Schriftfamilie",
      "customise-your-font": "Passen Sie Ihre Schriftart an",
      "match-your-store-look-and-feel-by-updating-the-font-across-your-size-charts": "Passen Sie das Erscheinungsbild Ihres Shops an, indem Sie die Schriftart in allen Ihren Größentabellen aktualisieren.",
      "select-a-font-from-the-list-bellow": "Wählen Sie eine Schriftart aus der untenstehenden Liste.",
      "search-font": "Schriftart suchen...",
      "fetching-fonts": "Schriftarten werden abgerufen...",
      "showing-x-fonts": "{{ x }} Schriftarten werden angezeigt",
      "sort-by-x": "Sortieren nach {{ x }}",
      "most-popular": "Am beliebtesten",
      "here-how-it-will-look-on-your-shop": "So wird es in Ihrem Shop aussehen",
      "it-ll-updated-across-all-your-chart-displays": "Es wird in allen Ihren Tabellenanzeigen aktualisiert.",
      "update-font-across-all-size-charts": "Schriftart in allen Größentabellen aktualisieren",
      "choose-a-font-to-match-your-store-style": "Wählen Sie eine Schriftart, die zum Stil Ihres Shops passt",
      "apply-font": "Schriftart anwenden",
      "font-applied-successfully": "Schriftart erfolgreich angewendet!",
      "manage-and-delete-your-uploaded-images-removing-a-file-is-permanent-and-cannot-be-undone": "Verwalten und löschen Sie Ihre hochgeladenen Bilder. Das Entfernen einer Datei ist endgültig und kann nicht rückgängig gemacht werden.",
      "do-you-want-to-delete-image": "Möchten Sie das Bild löschen?",
      "image-deleted-successfully": "Bild erfolgreich gelöscht",
      "chart-list": "Tabellenliste",
      "delete-x-dimensions": "{{ x }} Dimensionen löschen",
      "view-affecting-data": "Betroffene Daten anzeigen",
      "no-data-will-be-affected": "Es werden keine Daten betroffen sein.",
      "do-you-want-to-delete-selected-dimensions": "Möchten Sie die ausgewählten Dimensionen löschen?",
      "any-annotation-sets-and-charts-currently-using-these-dimensions-will-have-its-annotation-and-data-removed": "Bei allen Annotationssätzen und Tabellen, die diese Dimensionen derzeit verwenden, werden Annotation und Daten entfernt",
      "any-annotation-sets-and-charts-currently-using-these-dimensions-will-have-its-name-changed": "Bei allen Annotationssätzen und Tabellen, die diese Dimensionen derzeit verwenden, wird der Name geändert",
      "delete-dimension": "Dimension löschen",
      "successfully-deleted-dimension": "Dimension(en) erfolgreich gelöscht!",
      "successfully-update-dimension": "Dimension erfolgreich aktualisiert!",
      "configure-how-back-in-stock-notifications-work-for-your-customers": "Konfigurieren Sie, wie Benachrichtigungen bei Wiederverfügbarkeit für Ihre Kunden funktionieren",
      "activate-back-in-stock-notifications": "Benachrichtigungen bei Wiederverfügbarkeit aktivieren",
      "allow-shoppers-to-subscribe-for-alerts-when-a-size-or-product-is-sold-out-notifications-will-be-sent-automatically-once-stock-is-available": "Ermöglichen Sie Käufern, sich für Benachrichtigungen anzumelden, wenn eine Größe oder ein Produkt ausverkauft ist. Benachrichtigungen werden automatisch gesendet, sobald der Artikel wieder verfügbar ist.",
      "notification-channels": "Benachrichtigungskanäle",
      "third-party-service": "Drittanbieterdienst",
      "sms": "SMS",
      "coming-soon": "Demnächst verfügbar",
      "signup-experience-design": "Design der Anmeldeerfahrung",
      "form-display": "Formularanzeige",
      "modal-popup": "Modales Popup",
      "email-template-customisation": "Anpassung der E-Mail-Vorlage",
      "subject-line": "Betreffzeile",
      "subject-line-is-required": "Betreffzeile ist erforderlich",
      "your-size-is-back-in-stock": "Ihre Größe ist wieder verfügbar 🎉",
      "email-body": "E-Mail-Text",
      "inventory-threshold-setting": "Einstellung des Lagerbestandsgrenzwerts",
      "notify-shoppers-when-inventory-reaches-at-least": "Käufer benachrichtigen, wenn der Lagerbestand mindestens erreicht",
      "threshold-is-required": "Grenzwert ist erforderlich",
      "threshold-must-be-greater-than-0": "Grenzwert muss größer als 0 sein",
      "units": "Einheiten",
      "set-the-minimum-inventory-level-required-to-trigger-notifications": "Legen Sie den Mindestlagerbestand fest, der zum Auslösen von Benachrichtigungen erforderlich ist",
      "choose-a-service": "Dienst auswählen",
      "signing-out": "Abmeldung",
      "signout-of": "Abmelden von",
      "authenticate": "Authentifizieren",
      "save-settings": "Einstellungen speichern",
      "hi-your-is-now-back-in-stock-get-it-before-it-gone": "Hallo {{first_name}}, Ihr {{product_name}} ({{size_variant}}) ist jetzt wieder verfügbar. Sichern Sie es sich, bevor es wieder ausverkauft ist!",
      "successfully-updated-notification-back-in-stock": "Benachrichtigung bei Wiederverfügbarkeit erfolgreich aktualisiert",
      "preferred-language": "Bevorzugte Sprache",
      "successfully-updated-your-profile": "Ihr Profil wurde erfolgreich aktualisiert",
      "successfully-updated-mailing-subscription-status": "Newsletter-Abonnementstatus erfolgreich aktualisiert!",
      "upgrade-plan": "Plan aufwerten",
      "overview": "Übersicht",
      "billing-cycle": "Abrechnungszeitraum",
      "billing-cycle-resets-at-midnight-on-x-and-the-next-charge-is-on-y": "Der Abrechnungszeitraum wird um Mitternacht am {{ x }} zurückgesetzt, und die nächste Abbuchung erfolgt am {{ y }}",
      "billing-information": "Abrechnungsinformationen",
      "update-billing": "Abrechnung aktualisieren",
      "monthly-total": "Monatliche Gesamtsumme",
      "free-trial-x-days-left": "Kostenlose Testphase - noch {{ x }} Tage",
      "cancel-plan": "Plan kündigen",
      "change-plan": "Plan ändern",
      "plan-and-usage": "Plan und Nutzung",
      "tier-offers-in-use": "Genutzte Stufenangebote",
      "failed-to-cancel-plan": "Plan konnte nicht gekündigt werden",
      "total-usage": "Gesamtnutzung",
      "current-usage-summary": "Aktuelle Nutzungsübersicht",
      "published-charts": "Veröffentlichte Tabellen",
      "limit-reached": "Limit erreicht",
      "plan-details": "Plandetails",
      "current-plan": "Aktueller Plan",
      "select-a-reason": "Grund auswählen",
      "please-provide-your-reason": "Bitte geben Sie Ihren Grund an",
      "chart-preferences": "Tabellenpräferenzen",
      "skip-picking-dimensions-when-creating-a-new-chart-from-template": "Auswahl der Dimensionen beim Erstellen einer neuen Tabelle aus einer Vorlage überspringen",
      "border-color": "Randfarbe",
      "border-color-is-required": "Randfarbe ist erforderlich!",
      "list-of-charts-using-this-image": "Liste der Tabellen, die dieses Bild verwenden",
      "successfully-update-your-profile": "Ihr Profil wurde erfolgreich aktualisiert"
    },
    "analytic": {
      "failed-to-load-statistics": "Statistiken konnten nicht geladen werden",
      "total-chart-views": "Tabellenansichten",
      "total-add-to-cart": "In den Warenkorb",
      "traffic-by-location": "Traffic nach Standort",
      "desktop": "Desktop",
      "mobile": "Mobil",
      "size-recommendations": {
        "failed-to-load": "Analyse der Größenempfehlungen konnte nicht geladen werden",
        "total-suggestions-title": "Abgegebene Vorschläge",
        "conversion-title": "Konversion",
        "customers-proceeded": "Kunden sind dem Vorschlag gefolgt",
        "of-x-suggestions": "von {{count}} Vorschlägen",
        "most-suggested-title": "Am häufigsten vorgeschlagenes Produkt und Variante",
        "suggestions-count": "{{count}} Vorschläge",
        "most-common-profile-title": "Häufigstes Profil",
        "average-profile-title": "Durchschnittliches Profil",
        "gender": "Geschlecht",
        "age-group": "Altersgruppe",
        "height": "Größe",
        "weight": "Gewicht",
        "size-recommended": "Empfohlene Größe",
        "graph-suggestions": "Vorschläge",
        "graph-proceed": "Fortfahren",
        "source-all": "Alle",
        "source-chart": "Größentabelle",
        "source-table-chart": "Rastertabelle"
      },
      "chart-views": {
        "failed-to-load": "Tabellenansichten konnten nicht geladen werden",
        "device-types": "Gerätetypen",
        "most-viewed-chart": "Meistgesehene Tabelle",
        "most-viewed-product": "Meistgesehenes Produkt",
        "views-count": "{{ count }} Ansichten",
        "view-at": "Angesehen am",
        "location": "Standort",
        "graph-label": "Ansichten"
      },
      "add-to-cart": {
        "failed-to-load": "Analyse für In den Warenkorb konnte nicht geladen werden",
        "estimated-revenue": "Geschätzter beeinflusster Wert",
        "conversion-title": "Konversion von Tabellenansicht → In den Warenkorb",
        "most": "Häufigste Warenkorb-Zugaben",
        "adds-count": "{{count}} Warenkorb-Zugaben",
        "added-at": "Hinzugefügt am",
        "graph-label": "Warenkorb-Zugaben",
        "views-dataset-label": "Ansichten",
        "add-to-cart-dataset-label": "In den Warenkorb"
      },
      "stock-notifications": {
        "failed-to-load": "Analyse der Lagerbenachrichtigungen konnte nicht geladen werden",
        "failed-to-load-table": "Tabelle der Lagerbenachrichtigungen konnte nicht geladen werden",
        "total-subscriptions": "Abonnements",
        "total-notifications-sent": "Gesendete Benachrichtigungen",
        "delivery-rate": "Zustellrate",
        "opened-of-notified": "{{ opened }} geöffnet / {{ notified }} benachrichtigt",
        "most-subscribed": "Am häufigsten abonniert",
        "subscriptions-count": "{{ count }} Abonnements",
        "latest-subscribed": "Neuestes Abonnement",
        "subscribed-at": "Abonniert am: {{ date }}",
        "longest-waiting": "Längste Wartezeit auf Wiederauffüllung",
        "waiting-days": "Wartet: {{ days }} Tage",
        "waiting-since": "(seit {{ date }})",
        "subscriptions": "Abonnements",
        "notifications-sent": "Gesendete Benachrichtigungen",
        "opened": "Geöffnet",
        "at": "Am",
        "graph-label": "Abonnements"
      },
      "paid-gate": {
        "unlock-message": "Schalten Sie erweiterte Analysen frei, um vollständige Daten zu sehen und bessere Entscheidungen zu treffen.",
        "upgrade": "Aufwerten",
        "failed-to-fetch-plans": "Pläne konnten nicht abgerufen werden"
      },
      "buy-now": {
        "failed-to-load": "Analyse für Jetzt kaufen konnte nicht geladen werden",
        "total": "Jetzt kaufen",
        "estimated-revenue": "Geschätzter beeinflusster Wert",
        "conversion-title": "Konversion von Tabellenansicht → Jetzt kaufen",
        "most": "Meistgekauftes Produkt (Jetzt kaufen)",
        "buys-count": "{{count}} Jetzt-kaufen",
        "graph-label": "Jetzt kaufen",
        "views-dataset-label": "Ansichten",
        "buy-now-dataset-label": "Jetzt kaufen",
        "clicked-at": "Geklickt am"
      },
      "overview": {
        "funnel-title": "Was aus den Tabellenansichten wurde",
        "no-views-title": "Keine Tabellenansichten in diesem Zeitraum",
        "no-views-hint": "Größentabellen erscheinen auf Produktseiten, sobald sie veröffentlicht und Produkten zugewiesen sind.",
        "chart-views-caption": "Käufer, die eine Größentabelle geöffnet haben",
        "baseline-caption": "Alles Weitere wird an diesen Ansichten gemessen",
        "of-views": "von {{ count }} Ansichten",
        "not-in-funnel": "Nicht Teil des Tabellen-Funnels"
      },
      "preview": {
        "title": "Noch keine Daten — dies ist eine Vorschau",
        "message": "Die Zahlen unten sind Beispieldaten und zeigen, wie diese Seite aussieht, sobald Käufer Ihre Größentabellen nutzen."
      }
    },
    "plans": {
      "popular-plan": "Beliebter Plan",
      "try-now": "Jetzt testen",
      "activated": "Aktiviert",
      "contact-sales": "Vertrieb kontaktieren",
      "try-free-for-1-month": "1 Monat kostenlos testen",
      "activate": "Aktivieren",
      "what-included": "Was ist enthalten?",
      "choose-the-plan-that-fits-your-business-needs": "Wählen Sie den Plan, der zu Ihren Geschäftsanforderungen passt",
      "whether-youre-just-starting-out-or-looking-for-a-robust-sizing-solution-weve-got-a-plan-thats-right-for-you": "Egal, ob Sie gerade erst anfangen oder eine robuste Größenlösung suchen, wir haben einen Plan, der zu Ihnen passt.",
      "monthly": "Monatlich",
      "annually": "Jährlich",
      "compare-plan-features": "Planfunktionen vergleichen",
      "compare-all-plan-features": "Alle Planfunktionen vergleichen",
      "feature-usages": "Nutzung",
      "feature-analytics": "Analysen",
      "feature-support": "Support",
      "feature-integration": "Integration",
      "feature-branding": "Branding",
      "feature-api-access": "API-Zugriff",
      "feature-stock-notifications": "Lagerbenachrichtigungen",
      "feature-published-conversion-charts": "Veröffentlichte Konversionstabellen",
      "feature-advanced-variant-mapping": "Erweiterte Variantenzuordnung",
      "failed-to-fetch-plans": "Pläne konnten nicht abgerufen werden",
      "failed-to-activate-plan": "Plan konnte nicht aktiviert werden",
      "contact": {
        "title": "Vertrieb kontaktieren",
        "subtitle": "Erzählen Sie uns von Ihrem Shop und Ihren Anforderungen. Unser Team meldet sich per E-Mail bei Ihnen.",
        "message-placeholder": "Wie können wir Ihrem Unternehmen helfen?",
        "send": "Nachricht senden",
        "success": "Danke! Ihre Nachricht wurde gesendet. Unser Team meldet sich in Kürze bei Ihnen.",
        "first-name-required": "Vorname ist erforderlich",
        "last-name-required": "Nachname ist erforderlich",
        "email-required": "E-Mail ist erforderlich",
        "email-invalid": "E-Mail ist ungültig",
        "message-required": "Nachricht ist erforderlich"
      },
      "invite": {
        "title": "Abonnement abschließen",
        "your-plan": "Ihr Tarif",
        "order-summary": "Bestellübersicht",
        "billed-every-30-days": "Abrechnung alle 30 Tage",
        "billed-yearly": "Jährliche Abrechnung",
        "free-trial": "{{days}} Tage kostenlos testen",
        "due-today": "Heute fällig",
        "then-every-30-days": "Danach {{price}} USD alle 30 Tage",
        "then-yearly": "Danach {{price}} USD pro Jahr",
        "continue": "Weiter zur Genehmigung",
        "shopify-note": "Die Abrechnung erfolgt über Shopify. Sie genehmigen die Gebühr auf dem nächsten Bildschirm.",
        "switching-note": "Dies ersetzt Ihren aktuellen Tarif, sobald Sie zustimmen. Shopify schreibt die verbleibende Zeit gut.",
        "already-on-plan": "Sie nutzen diesen Tarif bereits",
        "unavailable-title": "Diese Einladung ist nicht mehr verfügbar",
        "unavailable-body": "Der Link ist möglicherweise abgelaufen. Wenden Sie sich an die Person, die ihn gesendet hat, oder sehen Sie sich die allgemein verfügbaren Tarife an.",
        "see-plans": "Tarife ansehen",
        "failed-title": "Dieser Tarif konnte nicht geladen werden",
        "failed-body": "Prüfen Sie Ihre Verbindung und laden Sie die Seite neu."
      }
    },
    "auth": {
      "signin": {
        "please-sign-in": "Bitte melden Sie sich an",
        "email-is-required": "E-Mail ist erforderlich",
        "invalid-email-address": "Ungültige E-Mail-Adresse",
        "password-is-required": "Passwort ist erforderlich",
        "sign-in": "Anmelden",
        "reset-password": "Passwort zurücksetzen",
        "generic-error": "Bei der Verarbeitung ist ein Fehler aufgetreten! Bitte versuchen Sie es später erneut."
      }
    },
    "admin": {
      "reports": {
        "title": "Berichte",
        "chart-views": {
          "title": "Tabellenansichten",
          "description": "Sehen Sie, wie oft Käufer die Größentabelle geöffnet haben, global über alle Shops hinweg.",
          "failed-to-load": "Bericht zu Tabellenansichten konnte nicht geladen werden",
          "total-views": "Tabellenansichten",
          "most-viewed-chart": "Meistgesehene Tabelle",
          "most-viewed-product": "Meistgesehenes Produkt",
          "views-count": "{{ count }} Ansichten",
          "traffic-by-location": "Traffic nach Standort",
          "device-types": "Gerätetypen",
          "desktop": "Desktop",
          "mobile": "Mobil",
          "top-stores": "Top-Shops",
          "no-top-stores": "Noch keine Shop-Daten",
          "graph-label": "Ansichten",
          "view-at": "Angesehen am",
          "location": "Standort"
        },
        "add-to-cart": {
          "title": "In den Warenkorb",
          "description": "Sehen Sie, wie sich die Größentabelle auf Warenkorb-Ereignisse auswirkt, global über alle Shops hinweg.",
          "failed-to-load": "Bericht zu In-den-Warenkorb konnte nicht geladen werden",
          "total-add-to-cart": "In den Warenkorb",
          "conversion-title": "Konversion von Tabellenansicht → In den Warenkorb",
          "most": "Häufigste Warenkorb-Zugaben",
          "adds-count": "{{ count }} Warenkorb-Zugaben",
          "top-stores": "Top-Shops",
          "no-top-stores": "Noch keine Shop-Daten",
          "graph-label": "Warenkorb-Zugaben",
          "views-dataset-label": "Ansichten",
          "add-to-cart-dataset-label": "In den Warenkorb",
          "added-at": "Hinzugefügt am"
        },
        "buy-now": {
          "title": "Jetzt kaufen",
          "description": "Sehen Sie, wie sich die Größentabelle auf Jetzt-kaufen-Ereignisse auswirkt, global über alle Shops hinweg.",
          "failed-to-load": "Bericht zu Jetzt-kaufen konnte nicht geladen werden",
          "total-buy-now": "Jetzt kaufen",
          "conversion-title": "Konversion von Tabellenansicht → Jetzt kaufen",
          "most": "Meistgekauftes Produkt (Jetzt kaufen)",
          "buys-count": "{{ count }} Jetzt-kaufen",
          "top-stores": "Top-Shops",
          "no-top-stores": "Noch keine Shop-Daten",
          "graph-label": "Jetzt kaufen",
          "views-dataset-label": "Ansichten",
          "buy-now-dataset-label": "Jetzt kaufen",
          "clicked-at": "Geklickt am"
        },
        "conversion-funnel": {
          "title": "Rastertabellen-Konversion",
          "description": "Sehen Sie, wo Händler aufgeben, wenn sie eine Rastertabelle in eine Größentabelle umwandeln, global über alle Shops hinweg.",
          "failed-to-load": "Bericht zur Rastertabellen-Konversion konnte nicht geladen werden",
          "total-runs": "Gestartete Konversionen",
          "runs-breakdown": "{{ converted }} konvertiert · {{ handedOver }} übergeben",
          "conversion-title": "Gestartet → Konvertiert",
          "handover-rate": "{{ rate }}% haben ihre Produkte anschließend übergeben",
          "handover-gap-title": "Konvertiert, nicht übergeben",
          "of-converted-runs": "der konvertierten Versuche",
          "handover-gap-description": "Eine Übergabe kann Tage später erfolgen, daher stehen einige davon noch aus, statt abgebrochen worden zu sein.",
          "funnel-title": "Konversionstrichter",
          "funnel-note": "Der dedizierte Übergabeschritt wird nicht mehr ausgelöst — der Banner ist jetzt der Weg, wie Übergaben abgeschlossen werden. Lesen Sie seine Anzahl daher als Gesamtzahl der Übergaben und nicht als Schrittkonversion.",
          "no-funnel": "Keine Konversionsversuche in diesem Zeitraum",
          "drop-off": "Abbruch",
          "runs-dataset-label": "Versuche",
          "drop-offs-title": "Wo Versuche enden",
          "drop-offs-description": "Die letzte Aktion jedes Versuchs. Versuche, die mit einer abgeschlossenen Übergabe enden — jetzt über den Banner erfasst — wurden erfolgreich abgeschlossen.",
          "no-drop-offs": "Keine Konversionsversuche in diesem Zeitraum",
          "dwell-title": "Zeit vor dem Verlassen",
          "dwell-description": "Wird nur erfasst, wenn ein Händler einen Schritt abbricht, plus die Zeit, die mit dem Lesen der Überprüfung vor der Bestätigung verbracht wurde.",
          "no-dwell": "Keine Zeitdaten in diesem Zeitraum",
          "step": "Schritt",
          "samples": "Stichproben",
          "median": "Median",
          "p90": "P90",
          "top-stores": "Top-Shops",
          "no-top-stores": "Noch keine Shop-Daten",
          "graph-label": "Gestartete Konversionen",
          "started-at": "Gestartet am",
          "duration": "Dauer",
          "last-step": "Letzter Schritt",
          "outcome": "Ergebnis",
          "steps": {
            "entry": "Dialog geöffnet",
            "category": "Kategorie",
            "mapping": "Zuordnung",
            "summary": "Überprüfung",
            "convert": "Konvertieren",
            "handover": "Übergabe",
            "banner": "Banner"
          },
          "actions": {
            "viewed": "angesehen",
            "completed": "abgeschlossen",
            "skipped": "übersprungen",
            "back": "zurückgegangen",
            "abandoned": "abgebrochen",
            "failed": "fehlgeschlagen",
            "customize_clicked": "Anpassen geklickt",
            "dismissed": "verworfen"
          },
          "outcomes": {
            "handed-over": "Übergeben",
            "converted": "Nur konvertiert",
            "failed": "Fehlgeschlagen",
            "abandoned": "Abgebrochen",
            "in-progress": "In Bearbeitung"
          }
        }
      },
      "delete-category": "Kategorie löschen",
      "do-you-want-to-delete-selected-categories": "Möchten Sie die ausgewählten Kategorien löschen?",
      "global-categories-are-shared-by-every-store": "Globale Kategorien werden von allen Shops gemeinsam genutzt — das Löschen einer Kategorie wirkt sich auf alle aus. Dies kann nicht rückgängig gemacht werden.",
      "successfully-deleted-category": "Kategorie erfolgreich gelöscht",
      "average-cost-per-recommendation": "Durchschnittliche Kosten pro Empfehlung",
      "failed-to-load-recommendations-average-cost": "Durchschnittliche Kosten der Empfehlungen konnten nicht geladen werden",
      "most-expensive-extract": "Teuerste Extraktion",
      "most-expensive-recommendation": "Teuerste Empfehlung",
      "total-recommendation-cost": "Gesamtkosten der Empfehlungen",
      "total-size-recommendation": "Größenempfehlungen",
      "total-sheet-extract": "Blattextraktionen",
      "new-category": "Neue Kategorie",
      "category-created-unlisted-hint": "Die Kategorie wurde ungelistet erstellt. Fügen Sie ein Bild und Maße hinzu, bevor Sie sie für Shops veröffentlichen.",
      "category-created-successfully": "Kategorie erfolgreich erstellt!",
      "category-search-placeholder": "Bildname, Shopname...",
      "dimension-search-placeholder": "Dimensionsname, Shopname...",
      "category-not-found": "Kategorie nicht gefunden",
      "sub-categories-variants": "Unterkategorien/Varianten:",
      "add-sub-category-variant": "Unterkategorie/Variante hinzufügen:",
      "from-existing": "Aus vorhandener",
      "create-a-new": "Eine neue erstellen",
      "sub-category-removed": "Unterkategorie entfernt!",
      "remove-sub-category": "Unterkategorie entfernen",
      "remove-sub-category-confirm": "{{ x }} aus dieser Kategorie entfernen? Sie bleibt als Top-Level-Kategorie verfügbar.",
      "update-category": "Kategorie aktualisieren",
      "published-category-hint": "Eine veröffentlichte Kategorie ist für alle Shops sichtbar. Ungelistete Kategorien bleiben verborgen.",
      "category-updated-successfully": "Kategorie erfolgreich aktualisiert!",
      "uninstalled": "Deinstalliert",
      "inactive": "Inaktiv",
      "install-at": "Installiert am",
      "total-chart-views": "Tabellenansichten",
      "chart-view-at": "Tabellenansicht am",
      "store-id": "Shop-ID",
      "successfully-deleted-clients": "Kunden erfolgreich gelöscht!",
      "session-replay": "Sitzungswiedergabe",
      "watch-on-amplitude": "Auf Amplitude ansehen",
      "shopify-app": "Shopify-App",
      "shops-online-store": "Online-Shop des Shops",
      "no-more-events-to-load": "Keine weiteren Ereignisse zum Laden!",
      "failed-to-fetch-events": "Ereignisse konnten nicht abgerufen werden!",
      "info": "Info",
      "store-info": "Shop-Informationen",
      "days-ago": "vor {{ x }} Tagen",
      "contact-email": "Kontakt-E-Mail",
      "store-url": "Shop-URL",
      "activities": "Aktivitäten",
      "insights": "Einblicke",
      "subscriptions": "Abonnements",
      "failed-to-fetch-client-info": "Kundeninformationen konnten nicht abgerufen werden!",
      "failed-to-load-add-to-cart-analytics": "Analyse für In den Warenkorb konnte nicht geladen werden",
      "failed-to-load-buy-now-analytics": "Analyse für Jetzt kaufen konnte nicht geladen werden",
      "failed-to-load-chart-views": "Tabellenansichten konnten nicht geladen werden",
      "failed-to-load-size-recommendations-analytics": "Analyse der Größenempfehlungen konnte nicht geladen werden",
      "failed-to-load-stock-notifications-analytics": "Analyse der Lagerbenachrichtigungen konnte nicht geladen werden",
      "failed-to-load-stock-notifications-table": "Tabelle der Lagerbenachrichtigungen konnte nicht geladen werden",
      "chart-views": "Tabellenansichten",
      "add-to-cart": "In den Warenkorb",
      "buy-now": "Jetzt kaufen",
      "size-recommendations": "Größenempfehlungen",
      "stock-notifications": "Lagerbenachrichtigungen",
      "change-details": "Details ändern",
      "plan-subscription-details": "Details zum Planabonnement",
      "ai-size-recommendation-limit": "Limit für KI-Größenempfehlung",
      "ai-size-recommendation-limit-required": "Limit für KI-Größenempfehlung ist erforderlich!",
      "minimum-limit-is-0": "Mindestlimit ist 0!",
      "unlimited": "Unbegrenzt",
      "chart-limit-drafts-hint": "Nur veröffentlichte Tabellen zählen. Entwürfe sind unbegrenzt.",
      "chart-limit-required": "Tabellenlimit ist erforderlich!",
      "chart-limit-whole-number": "Das Limit muss eine ganze Zahl sein!",
      "stock-notification-limit": "Limit für Lagerbenachrichtigungen",
      "stock-notification-limit-required": "Limit für Lagerbenachrichtigungen ist erforderlich!",
      "published-size-chart-limit": "Limit für veröffentlichte Größentabellen",
      "published-table-chart-limit": "Limit für veröffentlichte Rastertabellen",
      "analytic": "Analyse",
      "full-suite": "Vollständiges Paket",
      "select-a-subscription-plan": "Abonnementplan auswählen",
      "failed-to-fetch-plans": "Pläne konnten nicht abgerufen werden!",
      "new-plan": "Neuer Plan",
      "failed-to-assign-plan-subscription-to-client": "Planabonnement konnte dem Kunden nicht zugewiesen werden!",
      "ai-size-recommendation": "KI-Größenempfehlung",
      "stock-notification": "Lagerbenachrichtigung",
      "published-size-charts": "Veröffentlichte Größentabellen",
      "published-table-charts": "Veröffentlichte Rastertabellen",
      "analytic-access": "Analysezugriff",
      "activated-at": "Aktiviert am",
      "usages": "Nutzungen",
      "failed-to-fetch-client-plan-subscription": "Planabonnement des Kunden konnte nicht abgerufen werden!",
      "advanced-variant-mapping": "Erweiterte Variantenzuordnung",
      "advanced-variant-mapping-description": "Tabellen verwenden auf jedem zugewiesenen Produkt ihre eigenen Größen, und „In den Warenkorb“ wählt die passende Produktvariante. Wenn deaktiviert, müssen die Größen einer Tabelle exakt den Variantennamen jedes Produkts entsprechen.",
      "advanced-variant-mapping-counts": "{{ total }} Tabellen · {{ x }} mit erweiterter Variantenzuordnung",
      "advanced-variant-mapping-drift": "{{ x }} Tabellen entsprechen nicht dieser Einstellung.",
      "advanced-variant-mapping-repair": "Reparieren",
      "turn-on-advanced-variant-mapping": "Erweiterte Variantenzuordnung aktivieren?",
      "turn-off-advanced-variant-mapping": "Erweiterte Variantenzuordnung deaktivieren?",
      "advanced-variant-mapping-on-body": "Alle {{ x }} Tabellen dieses Kunden werden sofort umgestellt, und neue Tabellen verwenden sie ebenfalls. Die Maße werden nicht verändert, und Sie können sie wieder deaktivieren.",
      "advanced-variant-mapping-off-body": "Alle {{ x }} Tabellen dieses Kunden kehren zum exakten Abgleich der Variantennamen zurück. Tabellen, deren Größen umbenannt wurden, während die Funktion aktiv war (z. B. „Blue / S“ in „S“), zeigen bei Produkten, deren Variantennamen nicht mehr übereinstimmen, keine Maße an.",
      "turn-on": "Aktivieren",
      "turn-off": "Deaktivieren",
      "failed-to-fetch-advanced-variant-mapping": "Erweiterte Variantenzuordnung konnte nicht abgerufen werden!",
      "failed-to-update-advanced-variant-mapping": "Erweiterte Variantenzuordnung konnte nicht aktualisiert werden!",
      "plan-used-as-free-trial": "Plan als kostenlose Testphase für neu registrierte Kunden verwendet",
      "x-usages": "{{ x }} Nutzungen",
      "successfully-updated-configuration-value": "Konfigurationswert erfolgreich aktualisiert",
      "only-authorized-personnel-hint": "Nur autorisiertes Personal darf auf die globale Konfiguration der Anwendung zugreifen und diese ändern!",
      "password-is-required": "Passwort ist erforderlich",
      "authorize": "Autorisieren",
      "1-month": "1 Monat",
      "3-months": "3 Monate",
      "6-months": "6 Monate",
      "1-year": "1 Jahr",
      "failed-to-load-costs": "Kosten konnten nicht geladen werden",
      "failed-to-load-total-recommendations": "Gesamtzahl der Empfehlungen konnte nicht geladen werden",
      "archived": "Archiviert",
      "billing-interval": "Abrechnungsintervall",
      "plan-information": "Planinformationen",
      "name-is-required": "Name ist erforderlich!",
      "features": "Funktionen",
      "stock-notification-recommendation-limit": "Limit für Lagerbenachrichtigungsempfehlungen",
      "popular": "Beliebt",
      "allow-trial": "Testphase erlauben",
      "interval": "Intervall",
      "interval-is-required": "Intervall ist erforderlich!",
      "price-is-required": "Preis ist erforderlich!",
      "minimum-price-is-0": "Mindestpreis ist 0!",
      "discounted-from": "Rabattiert von",
      "description": "Beschreibung",
      "description-is-required": "Beschreibung ist erforderlich!",
      "selling-points": "Verkaufsargumente",
      "selling-point-x": "Verkaufsargument {{ x }}",
      "selling-point-is-required": "Verkaufsargument ist erforderlich!",
      "analytic-is-required": "Analyse ist erforderlich!",
      "support": "Support",
      "support-is-required": "Support ist erforderlich!",
      "status-is-required": "Status ist erforderlich!",
      "manage-preset-dimensions": "Verwalten Sie voreingestellte Dimensionen, deren Erkennungssynonyme und Übersetzungen.",
      "detection-synonyms": "Erkennungssynonyme",
      "add-synonym-placeholder": "Synonym eingeben und Enter drücken",
      "translations": "Übersetzungen",
      "missing-translation": "Fehlende Übersetzung",
      "new-dimension": "Neue Dimension",
      "edit-dimension": "Dimension bearbeiten",
      "delete-preset-dimension": "Voreingestellte Dimension löschen",
      "do-you-want-to-delete-this-preset-dimension": "Möchten Sie \"{{ name }}\" löschen?",
      "preset-dimensions-are-shared-by-every-store": "Voreingestellte Dimensionen werden von allen Shops gemeinsam genutzt — das Löschen einer Dimension entfernt sie aus allen Kategorien, die sie verwenden. Dies kann nicht rückgängig gemacht werden.",
      "successfully-created-dimension": "Dimension erfolgreich erstellt!",
      "successfully-updated-dimension": "Dimension erfolgreich aktualisiert!",
      "successfully-deleted-dimension": "Dimension erfolgreich gelöscht!",
      "ai-provider-for-file-imports": "KI-Anbieter für Dateiimporte",
      "no-api-key-configured-in-this-environment": "In dieser Umgebung ist kein API-Schlüssel konfiguriert",
      "ai-provider-saved-applies-to-new-imports": "KI-Anbieter gespeichert. Er gilt für neue Importe; laufende Importe behalten ihren Anbieter.",
      "ai-provider-for-size-recommendations": "KI-Anbieter für Größenempfehlungen",
      "ai-provider-saved-applies-to-next-recommendation": "KI-Anbieter gespeichert. Er gilt ab der nächsten Größenempfehlung.",
      "size-recommendation-provider-hint": "Wird für die KI-Größenempfehlungen für Kunden verwendet. Unabhängig von Dateiimporten.",
      "ai-measurement-import": "KI-Import von Maßen",
      "name-admin-only": "Name (nur für Admins)",
      "name-admin-only-hint": "Die App erkennt die Tarife Free und Enterprise an diesem Namen, benenne diese also nicht um.",
      "display-name": "Anzeigename",
      "display-name-hint": "Wird Händlern auf der Tarifseite, den Abrechnungsseiten und in der Shopify-Abbuchung angezeigt. Leer lassen, um den Namen zu verwenden.",
      "display-name-too-long": "Der Anzeigename darf höchstens 40 Zeichen lang sein!",
      "availability": "Verfügbarkeit",
      "available-from-utc": "Verfügbar ab (UTC)",
      "available-from-hint": "Leer lassen, um ihn anzubieten, sobald er aktiv ist.",
      "expires-at-utc": "Läuft ab am (UTC)",
      "expires-at-required": "Lege fest, wann er abläuft!",
      "window-order": "Er muss verfügbar werden, bevor er abläuft!",
      "your-time": "Deine Zeit: {{time}}",
      "availability-always": "Immer angeboten",
      "availability-scheduled": "Geplant: noch nicht angeboten",
      "availability-live": "Live: wird jetzt angeboten",
      "availability-ended": "Beendet: wird nicht mehr angeboten",
      "promo-plan": "Aktionstarif",
      "replaces-plan": "Ersetzt",
      "replaces-plan-none": "Nichts (ein regulärer Tarif)",
      "replaces-plan-hint": "Solange dieser Tarif angeboten wird, sehen Händler ihn anstelle des Tarifs, den er ersetzt.",
      "campaign": "Kampagne",
      "campaign-required": "Wähle die Kampagne, zu der dieser Aktionstarif gehört!",
      "merchants-see": "Händler sehen",
      "replaces-x": "ersetzt {{x}}",
      "archiving-hint": "Archivieren blendet einen Tarif nur für neue Abonnenten aus. Bestehende Abonnenten behalten ihn.",
      "duplicate-as-promo-plan": "Als Aktionstarif duplizieren",
      "help-articles": {
        "topic": "Thema",
        "all-topics": "Alle Themen",
        "topics": {
          "getting-started": "Erste Schritte",
          "size-charts": "Größentabellen",
          "table-charts": "Rastertabellen",
          "assigning-products": "Produkten zuweisen",
          "storefront-display": "Anzeige im Shop",
          "chart-import": "Tabellenimport",
          "size-recommendations": "Größenempfehlungen",
          "plans-billing": "Pläne und Abrechnung",
          "troubleshooting": "Fehlerbehebung"
        },
        "new-article": "Neuer Hilfeartikel",
        "slug": "Slug",
        "slug-hint": "Die Adresse des Artikels im Hilfecenter: /help/ihr-slug. Eine Änderung macht Links auf die alte Adresse ungültig.",
        "slug-invalid": "Verwenden Sie Kleinbuchstaben, Ziffern und einzelne Bindestriche.",
        "slug-taken": "Ein anderer Artikel verwendet diesen Slug bereits.",
        "title-is-required": "Titel ist erforderlich",
        "summary": "Zusammenfassung",
        "summary-hint": "Eine Zeile. Der Support-Assistent wählt Artikel anhand ihrer Zusammenfassung aus.",
        "summary-is-required": "Zusammenfassung ist erforderlich",
        "order": "Reihenfolge",
        "body-hint": "Markdown. Auf einen anderen Artikel verlinken Sie mit [Text](/help/sein-slug).",
        "insert-image": "Bild einfügen",
        "image-upload-failed": "Das Bild konnte nicht hochgeladen werden.",
        "view-on-help-centre": "Im Hilfecenter ansehen",
        "broken-links": "Veröffentlicht, aber diese Links führen zu Artikeln, die nicht existieren oder nicht veröffentlicht sind:",
        "article-saved": "Artikel gespeichert",
        "article-published": "Artikel veröffentlicht",
        "article-unpublished": "Veröffentlichung des Artikels aufgehoben",
        "article-deleted": "Artikel gelöscht",
        "delete-article": "Artikel löschen",
        "delete-article-prompt": "„{{title}}“ löschen? Der Artikel verschwindet sofort aus dem Hilfecenter und dem Support-Assistenten.",
        "load-failed": "Der Artikel konnte nicht geladen werden.",
        "export": "Exportieren",
        "import": "Importieren",
        "export-failed": "Die Artikel konnten nicht exportiert werden.",
        "import-title": "Hilfeartikel importieren",
        "import-checking": "Datei wird geprüft…",
        "import-preview": "{{file}} erstellt {{created}} und aktualisiert {{updated}} Artikel mit {{images}} Bildern. Artikel, die nicht in der Datei sind, bleiben unverändert.",
        "import-invalid": "Diese Datei kann nicht importiert werden:",
        "imported": "Importiert: {{created}} erstellt, {{updated}} aktualisiert."
      },
      "invite-only": "Nur auf Einladung",
      "invite-only-hint": "Auf der Tarifseite ausgeblendet. Jeder mit dem Link kann abonnieren. Dies kann nach dem Erstellen nicht mehr geändert werden.",
      "invite-only-price-required": "Ein Tarif nur auf Einladung braucht einen Preis über 0",
      "copy-invite-link": "Einladungslink kopieren",
      "invite-link-copied": "Einladungslink kopiert",
      "invite-link-copy-failed": "Einladungslink konnte nicht kopiert werden"
    }
  },
  "search": {
    "no-result-found": "Kein Ergebnis gefunden!",
    "type": {
      "product": "Produkt",
      "variant": "Variante",
      "client": "Kunde"
    },
    "show-less": "Weniger anzeigen",
    "show-full": "Alles anzeigen",
    "search-x-by-full-name": "{{ x }} nach vollständigem Namen suchen",
    "load-more...": "Mehr laden..."
  },
  "privacy-policy": "Datenschutzrichtlinie",
  "contact-us": "Kontaktieren Sie uns",
  "notification": {
    "notification": "Benachrichtigung",
    "mark-all-as-read": "Alle als gelesen markieren",
    "compose": "Benachrichtigung verfassen",
    "title-required": "Titel ist erforderlich!",
    "message-required": "Nachricht ist erforderlich!",
    "sent-to-all-clients": "Eine Benachrichtigung wurde an alle Kunden gesendet"
  },
  "table": {
    "sort": "Sortieren",
    "sort-by": "Sortieren nach",
    "oldest-first": "Älteste zuerst",
    "newest-first": "Neueste zuerst",
    "a-z": "A bis Z",
    "z-a": "Z bis A",
    "lowest-first": "Niedrigste zuerst",
    "highest-first": "Höchste zuerst",
    "no-data-found": "Keine Daten gefunden"
  },
  "grading": {
    "grading-configuration": "Gradierungskonfiguration",
    "base-size": "Basisgröße",
    "enter-your-grading-allowances": "Geben Sie Ihre Gradierungstoleranzen ein",
    "base": "Basis"
  },
  "chart": {
    "image-nav-previous": "Vorheriges Bild",
    "image-nav-next": "Nächstes Bild",
    "image-nav-position": "{{current}} / {{total}}",
    "image-add-slot-placeholder": "Weiteres Bild hinzufügen",
    "image-add-slot-formats": "Akzeptiert .png, .jpeg, .jpg",
    "image-cap-reached": "Sie haben die maximale Anzahl an Bildern für diese Kategorie erreicht.",
    "image-upload-failed": "Das Bild konnte nicht hochgeladen werden. Bitte versuchen Sie es erneut.",
    "image-svg-not-accepted": "SVG-Dateien werden hier nicht akzeptiert.",
    "image-delete": "Bild löschen",
    "image-move-left": "Bild nach links verschieben",
    "image-move-right": "Bild nach rechts verschieben",
    "image-delete-confirm-title": "Dieses Bild löschen?",
    "image-delete-confirm-body": "Dieses Bild wird dauerhaft entfernt und kann nicht wiederhergestellt werden.",
    "image-delete-confirm-cancel": "Abbrechen",
    "image-delete-confirm-action": "Bild löschen",
    "image-delete-last-tooltip": "Eine Kategorie muss mindestens ein Bild behalten.",
    "image-customize-first-tooltip": "Passen Sie diese Kategorie zuerst an, um ihre Bilder zu verwalten.",
    "image-delete-failed": "Das Bild konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.",
    "image-reorder-failed": "Die Bilder konnten nicht neu angeordnet werden. Bitte versuchen Sie es erneut.",
    "do-you-want-to-delete-this-chart": "Möchten Sie diese Tabelle löschen?",
    "unnamed-chart": "Unbenannte Tabelle",
    "get-size-chart-permalink": "Permalink zur Größentabelle abrufen",
    "chart-external-link-is-copied-to-clipboard": "Externer Link der Tabelle wurde in die Zwischenablage kopiert",
    "failed-to-duplicate-chart": "Tabelle konnte nicht dupliziert werden",
    "failed-to-create-chart": "Tabelle konnte nicht erstellt werden",
    "add-new-layout-blocks": "Neue Layout-Blöcke hinzufügen",
    "click-on-these-layout-types-and-add-to-the-size-chart": "Klicken Sie auf diese Layout-Typen und fügen Sie sie der Größentabelle hinzu",
    "rename-chart": "Tabelle umbenennen",
    "chart-renamed-successfully": "Tabelle erfolgreich umbenannt",
    "failed-to-rename-chart": "Tabelle konnte nicht umbenannt werden",
    "preview": "Vorschau",
    "model-info": "Modellinformationen",
    "model-details": "Modelldetails",
    "help-shoppers-by-showing-the-model-height-and-size": "Helfen Sie Käufern, indem Sie Größe und Konfektionsgröße des Modells anzeigen",
    "model-name": "Modellname",
    "enter-model-name": "Modellnamen eingeben",
    "model-height": "Modellgröße",
    "please-enter-valid-number": "Bitte geben Sie eine gültige Zahl ein",
    "size-worn": "Getragene Größe",
    "show-variants-by": "Varianten anzeigen nach",
    "add-options-like-size-or-color": "Optionen wie Größe oder Farbe hinzufügen",
    "select-existing-chart": "Vorhandene Tabelle auswählen",
    "search-charts": "Tabellen nach Namen suchen",
    "no-charts-found": "Keine Tabellen gefunden",
    "search-dimensions": "Dimensionen suchen",
    "no-dimensions-found": "Keine Dimensionen gefunden",
    "add-a-new-size-chart": "Neue Größentabelle hinzufügen",
    "this-product-is-using-table-chart": "Dieses Produkt verwendet eine Rastertabelle",
    "update-your-size-chart": "Aktualisieren Sie Ihre Größentabelle",
    "create-your-size-chart": "Erstellen Sie Ihre Größentabelle",
    "use-a-template": "Eine Vorlage verwenden",
    "use-template-variants": "Vorlage & Varianten verwenden",
    "pick-a-method-to-get-started": "Wählen Sie eine Methode, um loszulegen",
    "select-an-existing-chart": "Eine vorhandene Tabelle auswählen",
    "image-set-annotation-panel": "Annotationsbereich für Bildsatz",
    "measure-guide": "Maßleitfaden...",
    "drag-drop-to-mark-measurement-bubble": "Ziehen und ablegen, um die Messblase zu markieren",
    "are-you-sure-you-want-to-delete-all-measurements": "Möchten Sie wirklich alle Maße löschen?",
    "accepts-png-jpeg-jpg-svg": "Akzeptiert .png, .jpeg, .jpg, .svg",
    "this-name-will-appear-in": "Dieser Name wird angezeigt in",
    "image-set": "Bildsatz",
    "added-measurements": "Hinzugefügte Maße",
    "no-measurements-added-yet": "Noch keine Maße hinzugefügt",
    "drag-and-drop-a-chip-to-edit-its-line-on-the-canvas": "Ziehen Sie ein Chip, um dessen Linie auf der Leinwand zu bearbeiten",
    "after-adding-a-measurement-drag-and-drop-it-from-the-section-above-onto-the-image": "Ziehen Sie das Maß nach dem Hinzufügen aus dem Abschnitt „Hinzugefügte Maße“ oben auf das Bild",
    "across-shoulder-front-rise-belt": "Schulterbreite, vorderer Schritt, Gürtel, ...",
    "create-measurement": "Maß erstellen",
    "examples-across-shoulder-front-rise-cuff-width": "Beispiele: „Schulterbreite“, „Vorderer Schritt“, „Manschettenbreite“",
    "delete-anotation-set": "Annotationssatz löschen",
    "this-will-remove-all-measurements-from-this-image": "Dadurch werden alle Maße von diesem Bild entfernt",
    "measurement-name": "Maßname",
    "size-recommender": "Größenempfehler",
    "size-recommender-history": "Neueste Empfehlungen",
    "your-buyer-personal-fitting-assistant-that-instantly-suggests-the-perfect-size-every-time": "Der persönliche Anpassungsassistent Ihrer Käufer, der jedes Mal sofort die perfekte Größe vorschlägt",
    "stretch-factor": "Dehnungsfaktor",
    "how-stretchy-is-the-fabric-a-rough-estimate-is-enough-if-unsure-then-leave-at-10": "Wie dehnbar ist der Stoff? Eine grobe Schätzung reicht aus. Wenn Sie unsicher sind, lassen Sie es bei 10%",
    "easing": "Bewegungsfreiheit",
    "wearing-ease-is-the-amount-added-to-a-person-body-measurements-so-one-can-move-in-a-garment": "Die Bewegungsfreiheit ist der Betrag, der zu den Körpermaßen einer Person hinzugefügt wird, damit man sich in einem Kleidungsstück bewegen kann.",
    "set-default": "Als Standard festlegen",
    "suggested": "Vorgeschlagen",
    "assign-chart": "Tabelle zuweisen",
    "your-chart-has-not-been-assigned-to-any-product-yet": "Ihre Tabelle wurde noch keinem Produkt zugewiesen",
    "assign-your-chart-so-it-will-appear-on-product-pages": "Weisen Sie Ihre Tabelle zu, damit sie auf Produktseiten erscheint",
    "assign-it-to-a-product": "Einem Produkt zuweisen",
    "select-the-products-or-collections-where-you-want-your-size-chart-to-appear": "Wählen Sie die Produkte oder Kollektionen aus, in denen Ihre Größentabelle erscheinen soll",
    "x-matched-y": "{{ x }} stimmte überein mit {{ y }}",
    "overwritting-x-products": "(überschreibt {{ x }} Produkte)",
    "calculating...": "Wird berechnet...",
    "select-product-or-collection": "Produkt oder Kollektion auswählen",
    "remove-all": "Alle entfernen",
    "are-you-sure-you-want-to-remove-all-conditions": "Möchten Sie wirklich alle Bedingungen entfernen?",
    "list-of-matched-products": "Liste der übereinstimmenden Produkte",
    "give-your-size-chart-a-name": "Geben Sie Ihrer Größentabelle einen Namen",
    "this-name-is-only-used-internally-to-help-you-organise-your-charts-customers-wont-see-it": "Dieser Name wird nur intern verwendet, um Ihnen bei der Organisation Ihrer Tabellen zu helfen. Kunden sehen ihn nicht.",
    "eg-mens-t-shirt-size-chart": "z.B. Größentabelle für Herren-T-Shirts",
    "add-text-block": "Textblock hinzufügen",
    "product-image-optional": "Produktbild (optional)",
    "add-layout-block": "Layout-Block hinzufügen",
    "move-this-block-up": "Diesen Block nach oben verschieben",
    "move-this-block-down": "Diesen Block nach unten verschieben",
    "clear-this-image": "Dieses Bild löschen",
    "align-this-image": "Dieses Bild ausrichten",
    "clear-this-video": "Dieses Video löschen",
    "apply-grading-to-this-table": "Gradierung auf diese Tabelle anwenden",
    "duplicate-this-block-to-below": "Diesen Block nach unten duplizieren",
    "remove-this-block": "Diesen Block entfernen",
    "upload-an-image": "Ein Bild hochladen",
    "browse-to-upload": "Zum Hochladen durchsuchen",
    "choose-from-our": "Wählen Sie aus unseren",
    "ready-made-templates": "fertigen Vorlagen",
    "select-a-template": "Eine Vorlage auswählen",
    "new-row": "Neue Zeile",
    "new-column": "Neue Spalte",
    "add-column-left": "Spalte links hinzufügen",
    "add-column-right": "Spalte rechts hinzufügen",
    "move-left": "Nach links verschieben",
    "move-right": "Nach rechts verschieben",
    "freeze": "Fixieren",
    "unfreeze": "Fixierung aufheben",
    "delete-column": "Spalte löschen",
    "add-row-above": "Zeile oberhalb hinzufügen",
    "add-row-below": "Zeile unterhalb hinzufügen",
    "move-up": "Nach oben verschieben",
    "move-down": "Nach unten verschieben",
    "delete-row": "Zeile löschen",
    "insert-video": "Video einfügen",
    "select-a-video": "Ein Video auswählen",
    "paste-a-link-to-a-video-here": "Fügen Sie hier einen Link zu einem Video ein",
    "webgl-not-supported": "Ihr Browser unterstützt WebGL nicht. Bitte aktivieren Sie die WebGL-Unterstützung, wenn Sie einen modernen Browser wie Chrome, Firefox oder Safari verwenden.",
    "table-chart-created": "Rastertabelle erstellt",
    "name-this-image-set": "Diesen Bildsatz benennen",
    "name-your-import": "Benennen Sie Ihren Import",
    "table-chart-updated": "Rastertabelle aktualisiert",
    "chart-updated": "Tabelle aktualisiert",
    "use-how-to-measure-block": "Anleitungsblock „So messen Sie“ verwenden? (Optional)",
    "a-text-block-under-an-expandable-panel-will-be-added-where-you-can-fill-in-details-for-your-customers-on-how-to-measure-their-measurements": "Ein Textblock unter einem erweiterbaren Panel wird hinzugefügt, in dem Sie für Ihre Kunden Details dazu ausfüllen können, wie sie ihre Maße nehmen",
    "newest-5-recommendations-given-to-your-customers": "Die neuesten 5 Empfehlungen, die Ihren Kunden gegeben wurden",
    "size-recommended": "Empfohlene Größe",
    "view-all-data": "Alle Daten anzeigen",
    "please-select-a-size-worn": "Bitte wählen Sie eine getragene Größe aus",
    "recommended-for-this-garment-add-or-remove-as-needed": "Empfohlen für dieses Kleidungsstück, nach Bedarf hinzufügen oder entfernen",
    "add-more": "Mehr hinzufügen",
    "add-custom-measurements": "Benutzerdefinierte Maße hinzufügen",
    "skip-this-step-next-time": "Diesen Schritt nächstes Mal überspringen",
    "use-unit-conversion": "Einheitenumrechnung verwenden",
    "disabled-by-chart": "Durch Tabelle deaktiviert",
    "disabled-globally-by-settings": "Global durch Einstellungen deaktiviert",
    "hide-unit-conversion-toggle-on-all-charts-appear-on-your-storefront": "Umschalter für Einheitenumrechnung auf allen Tabellen in Ihrem Shop ausblenden",
    "assign-products": "Produkte zuweisen",
    "select-products-to-assign-to-the-chart": "Produkte auswählen, die der Tabelle zugewiesen werden sollen",
    "products-assigned-successfully": "Produkte erfolgreich zugewiesen",
    "source-table": "Quelltabelle",
    "root-table": "Haupttabelle",
    "table-block": "Tabelle",
    "which-axis-holds-the-dimension-data": "Welche Achse enthält die Dimensionsdaten? (Schulter, Taille, usw.)",
    "columns": "Spalten",
    "rows": "Zeilen",
    "measurement-unit": "Maßeinheit",
    "map-each-line-to-a-dimension": "Jede Zeile einer Dimension zuordnen",
    "ignore": "Ignorieren",
    "line": "Zeile",
    "the-selected-table-has-no-data-to-map": "Die ausgewählte Tabelle hat keine Daten zum Zuordnen.",
    "tell-us-how-your-table-maps-to-body-dimensions-so-we-can-suggest-a-size": "Sagen Sie uns, wie Ihre Tabelle den Körperdimensionen zugeordnet wird, damit wir eine Größe vorschlagen können.",
    "choose-which-table-the-ai-reads-to-suggest-a-size": "Wählen Sie aus, welche Tabelle die KI liest, um eine Größe vorzuschlagen.",
    "per-dimension-stretch-and-easing-controls": "Dehnungs- und Bewegungsfreiheitssteuerung pro Dimension",
    "jump-to-table": "Zur Tabelle springen",
    "scroll-to-the-selected-table": "Zur ausgewählten Tabelle scrollen",
    "this-table-is-used-as-your-size-recommendation-data-source": "Diese Tabelle wird als Datenquelle für Ihre Größenempfehlung verwendet",
    "this-table-block-can-not-be-deleted-right-now": "Dieser Tabellenblock kann derzeit nicht gelöscht werden"
  },
  "error": {
    "there-was-an-error-while-authenticating-your-store": "Bei der Authentifizierung Ihres Shops ist ein Fehler aufgetreten!",
    "click-the-button-below-to-try-again-if-the-issue-persisted-contact-us-for-further-instruction": "Klicken Sie auf die Schaltfläche unten, um es erneut zu versuchen. Wenn das Problem weiterhin besteht, kontaktieren Sie uns für weitere Anweisungen.",
    "refresh-the-app": "App aktualisieren",
    "error-occured": "Es ist ein Fehler aufgetreten!"
  },
  "banner": {
    "add-the-goodchart-size-guide-button-to-your-storefront": "Fügen Sie die Goodchart-Größenleitfaden-Schaltfläche zu Ihrem Shop hinzu",
    "we-ve-detected-you-are-integrating-with-shopify-enable-app-embed-or-add-an-app-block": "Wir haben festgestellt, dass Sie sich mit Shopify integrieren. Aktivieren Sie App-Einbettung, um die Größenleitfaden-Schaltfläche automatisch auf jeder Produktseite anzuzeigen, oder fügen Sie einen App-Block hinzu, um sie an einer bestimmten Stelle zu platzieren. Benötigen Sie Hilfe? Sehen Sie sich diese <a class=\"underline\" href=\"{{ guide }}\" target=\"_blank\">Anleitung</a> an.",
    "enable-app-embed": "App-Einbettung aktivieren",
    "add-app-block": "App-Block hinzufügen",
    "your-new-size-chart-is-ready-to-review": "Ihre neue Größentabelle ist bereit zur Überprüfung",
    "look-around-then-hand-the-conversion-over": "Für Ihre Käufer hat sich noch nichts geändert — Ihre Rastertabelle ist noch die aktive. Nehmen Sie sich Zeit, um die Maße und den Leitfaden zu überprüfen, und übergeben Sie dann die Konversion, wenn alles stimmt.",
    "about-your-plan-usage": "Zu Ihrer Plan-Nutzung",
    "measurements-applied": "Maße angewendet",
    "selection-applied-all-variants": "Die Auswahl wurde auf alle Größenvarianten angewendet.",
    "you-have-reached-x-of-ai-size-recommendations-limit": "Sie haben {{ x }}% des Limits für KI-Größenempfehlungen Ihres aktuellen Tarifplans erreicht. Bitte beachten Sie, dass jede Nutzung über 100% zum Standardtarif berechnet wird.",
    "you-have-reached-x-of-stock-notification-limit": "Sie haben {{ x }}% des Limits für Lagerbenachrichtigungen Ihres aktuellen Tarifplans erreicht.",
    "over-usage-cost": "Übernutzungskosten",
    "you-have-exceeded-ai-size-recommendation-limit-pay-to-continue-using-service": "Sie haben Ihr Limit für KI-Größenempfehlungen überschritten. Bitte fahren Sie fort, die Übernutzungskosten zu bezahlen, um den Dienst weiterhin zu nutzen.",
    "you-have-exceeded-ai-size-recommendation-limit-pay-to-continue-using-this-feature": "Sie haben Ihr Limit für KI-Größenempfehlungen überschritten. Bitte fahren Sie fort, die Übernutzungskosten zu bezahlen, um diese Funktion weiterhin zu nutzen.",
    "n-of-your-table-charts-can-be-upgraded-to-smart-size-charts": "{{count}} Ihrer Rastertabellen können zu intelligenten Größentabellen aufgewertet werden"
  },
  "onboarding": {
    "skip-for-now": "Vorerst überspringen",
    "step-x-of-y": "Schritt {{ x }} von {{ y }}",
    "select-the-category-that-best-matches-your-product": "Wählen Sie die Kategorie aus, die am besten zu Ihrem Produkt passt.",
    "apparel": "Bekleidung",
    "tops": "Oberteile",
    "pants": "Hosen",
    "dresses": "Kleider",
    "shoes": "Schuhe",
    "sneakers": "Sneaker",
    "boots": "Stiefel",
    "sandals": "Sandalen",
    "accessories": "Accessoires",
    "belts": "Gürtel",
    "bags": "Taschen",
    "hats": "Hüte",
    "other-custom": "Andere/Benutzerdefiniert",
    "equipment": "Ausrüstung",
    "tool": "Werkzeug",
    "furniture": "Möbel",
    "upload-any-product-image-and-place-measurements-visually-works-for-apparel-shoes-and-accessories": "Laden Sie ein beliebiges Produktbild hoch und platzieren Sie Maße visuell. Funktioniert für Bekleidung, Schuhe und Accessoires.",
    "table-style-chart": "Tabellenstil-Tabelle",
    "create-a-grid-based-chart-with-rows-and-columns-best-for-detailed-size-specifications": "Erstellen Sie eine rasterbasierte Tabelle mit Zeilen und Spalten. Am besten für detaillierte Größenangaben.",
    "your-size-chart-is-ready": "Ihre Größentabelle ist fertig",
    "you-can-now-decide-where-this-size-chart-should-appear-in-your-store-you-can-skip-this-step-and-assign-products-later": "Sie können jetzt entscheiden, wo diese Größentabelle in Ihrem Shop erscheinen soll. Sie können diesen Schritt überspringen und Produkte später zuweisen.",
    "apply-this-chart-to-products-now": "Diese Tabelle jetzt auf Produkte anwenden",
    "choose-which-products-should-use-this-size-chart": "Wählen Sie aus, welche Produkte diese Größentabelle verwenden sollen.",
    "i-ll-do-this-later": "Das mache ich später",
    "you-can-assign-or-change-matching-anytime-from-chart-settings": "Sie können die Zuweisung oder Zuordnung jederzeit über die Tabelleneinstellungen ändern.",
    "select-products-to-assign-chart-to": "Produkte auswählen, denen die Tabelle zugewiesen werden soll",
    "apply-this-chart-to-all-products": "Diese Tabelle auf alle Produkte anwenden.",
    "select-products-to-apply-this-chart-to": "Produkte auswählen, auf die diese Tabelle angewendet werden soll.",
    "assigning...": "Wird zugewiesen...",
    "size-chart-created-successfully": "Größentabelle erfolgreich erstellt",
    "you-can-assign-products-anytime-from-chart-settings": "Sie können Produkte jederzeit über die Tabelleneinstellungen zuweisen.",
    "view-chart": "Tabelle ansehen",
    "go-to-dashboard": "Zum Dashboard",
    "turn-your-size-chart-into-a-conversion-tool": "Verwandeln Sie Ihre Größentabelle in ein Konversionswerkzeug",
    "help-shoppers-pick-the-right-size-and-reduce-returns": "Helfen Sie Käufern, die richtige Größe zu wählen, und reduzieren Sie Retouren.",
    "setup-takes-about-2-minutes": "Die Einrichtung dauert etwa 2 Minuten.",
    "choose-how-your-size-chart-looks": "Wählen Sie, wie Ihre Größentabelle aussehen soll",
    "other-ways-to-create-a-chart": "Andere Möglichkeiten, eine Tabelle zu erstellen",
    "failed-to-proceed-please-try-again": "Fortfahren fehlgeschlagen, bitte versuchen Sie es erneut",
    "this-chart-connects-to-your-shopify-product-and-variants-so-shoppers-can-select-their-size-add-to-cart-or-buy-now-without-leaving-the-chart": "Diese Tabelle verbindet sich mit Ihrem Shopify-Produkt und den Varianten, sodass Käufer ihre Größe auswählen, in den Warenkorb legen oder jetzt kaufen können, ohne die Tabelle zu verlassen",
    "add-the-size-guide-button-to-your-storefront": "Fügen Sie die Größenleitfaden-Schaltfläche zu Ihrem Shop hinzu",
    "choose-how-the-goodchart-size-guide-button-should-appear-on-your-product-pages": "Wählen Sie, wie die GoodChart-Größenleitfaden-Schaltfläche auf Ihren Produktseiten erscheinen soll.",
    "enable-app-embed": "App-Einbettung aktivieren",
    "installed": "Installiert",
    "automatically-display-the-size-guide-button-on-all-product-pages": "Zeigen Sie die Größenleitfaden-Schaltfläche automatisch auf allen Produktseiten an.",
    "add-app-block-to-product-page": "App-Block zur Produktseite hinzufügen",
    "prefer-to-place-the-button-in-a-specific-spot-on-your-product-page": "Möchten Sie die Schaltfläche lieber an einer bestimmten Stelle auf Ihrer Produktseite platzieren?",
    "place-the-size-guide-button-in-a-specific-spot-on-your-product-page-template": "Platzieren Sie die Größenleitfaden-Schaltfläche an einer bestimmten Stelle in Ihrer Produktseiten-Vorlage.",
    "open": "Öffnen",
    "check-button-installation": "Installation der Schaltfläche prüfen",
    "checking": "Wird geprüft...",
    "great-the-size-guide-button-is-installed-on-your-storefront": "Großartig! Die Größenleitfaden-Schaltfläche ist in Ihrem Shop installiert.",
    "we-could-not-detect-the-size-guide-button-yet-please-make-sure-you-saved-the-changes-in-the-theme-editor": "Wir konnten die Größenleitfaden-Schaltfläche noch nicht erkennen. Bitte stellen Sie sicher, dass Sie die Änderungen im Theme-Editor gespeichert haben.",
    "app-block-installed-on-your-product-page": "App-Block auf Ihrer Produktseite installiert"
  },
  "common": {
    "updated": "Aktualisiert",
    "name": "Name",
    "avatar": "Avatar",
    "category-image": "Kategoriebild",
    "increase": "Erhöhen",
    "created": "Erstellt",
    "email": "E-Mail",
    "password": "Passwort",
    "yes": "Ja",
    "no": "Nein",
    "chart": "Tabelle",
    "gender": "Geschlecht",
    "height": "Größe",
    "weight": "Gewicht",
    "age-group": "Altersgruppe",
    "fit-preference": "Passformpräferenz",
    "score": "Punktzahl",
    "table-chart": "Rastertabelle",
    "draft": "Entwurf",
    "active": "Aktiv",
    "products": "Produkte",
    "none": "Keine",
    "cancel": "Abbrechen",
    "retry": "Erneut versuchen",
    "delete": "Löschen",
    "export": "Exportieren",
    "variant": "Variante",
    "variants": "Varianten",
    "account": "Konto",
    "personal": "Persönlich",
    "appearance": "Erscheinungsbild",
    "organization": "Organisation",
    "information": "Informationen",
    "first-name": "Vorname",
    "last-name": "Nachname",
    "save": "Speichern",
    "pay": "Bezahlen",
    "undo": "Rückgängig",
    "redo": "Wiederholen",
    "newsletter-subscription": "Newsletter-Abonnement",
    "button": "Schaltfläche",
    "colour": "Farbe",
    "default": "Standard",
    "white": "Weiß",
    "light-grey": "Hellgrau",
    "soft-beige": "Sanftes Beige",
    "saving...": "Wird gespeichert...",
    "all-changes-saved": "Alle Änderungen gespeichert",
    "publish": "Veröffentlichen",
    "unpublish": "Veröffentlichung aufheben",
    "images": "Bilder",
    "charts": "Tabellen",
    "confirm": "Bestätigen",
    "dimensions": "Dimensionen",
    "new": "Neu",
    "missing": "Fehlend",
    "editing-x": "{{ x }} wird bearbeitet",
    "back-in-stock": "Wieder verfügbar",
    "product": "Produkt",
    "grading": "Gradierung",
    "more-actions": "Weitere Aktionen",
    "table": "Tabelle",
    "measurement": "Maß",
    "close": "Schließen",
    "apply": "Anwenden",
    "duplicate": "Duplizieren",
    "add-layout-blocks": "Layout-Blöcke hinzufügen",
    "text": "Text",
    "image": "Bild",
    "video": "Video",
    "new-name": "Neuer Name",
    "published": "Veröffentlicht",
    "all": "Alle",
    "editing": "Wird bearbeitet",
    "show-more": "Mehr anzeigen",
    "loading": "Wird geladen",
    "or": "Oder",
    "browse-files": "Dateien durchsuchen",
    "edit": "Bearbeiten",
    "customize": "Anpassen",
    "clear": "Löschen",
    "label": "Beschriftung",
    "discard-changes": "Änderungen verwerfen",
    "uploading": "Wird hochgeladen...",
    "preset": "Voreinstellung",
    "custom": "Benutzerdefiniert",
    "manage": "Verwalten",
    "done": "Fertig",
    "reminder": "Erinnerung",
    "collections": "Kollektionen",
    "all-products": "Alle Produkte",
    "select": "Auswählen",
    "search": "Suchen",
    "select-all": "Alle auswählen",
    "size-chart": "Größentabelle",
    "continue": "Fortfahren",
    "back": "Zurück",
    "visual-measurement-builder": "Visueller Maß-Builder",
    "recommend": "Empfehlen",
    "creating...": "Wird erstellt...",
    "syncing": "Wird synchronisiert...",
    "preview": "Vorschau",
    "create": "Erstellen",
    "onboarding": "Onboarding",
    "english": "English",
    "french": "Français",
    "spanish": "Español",
    "czech": "Čeština",
    "danish": "Dansk",
    "german": "Deutsch",
    "italian": "Italienisch",
    "dutch": "Niederländisch",
    "japanese": "Japanisch",
    "off": "Aus",
    "basic": "Basis",
    "AI": "KI",
    "details": "Details",
    "date": "Datum",
    "billing": "Abrechnung",
    "settings": "Einstellungen",
    "log-out": "Abmelden",
    "plan": "Plan",
    "ai-size-recommendation": "KI-Größenempfehlung",
    "recommendations": "Empfehlungen",
    "features": "Funktionen",
    "stock-notification": "Lagerbenachrichtigung",
    "published-size-charts": "Veröffentlichte Größentabellen",
    "published-table-charts": "Veröffentlichte Rastertabellen",
    "unlimited": "Unbegrenzt",
    "x-of-y": "{{ x }} von {{ y }}",
    "measurements": "Maße",
    "selected": "Ausgewählt",
    "select-product": "Produkt auswählen",
    "price": "Preis",
    "title": "Titel",
    "message": "Nachricht",
    "add": "Hinzufügen",
    "remove": "Entfernen",
    "cm": "cm",
    "in": "Zoll",
    "usd": "USD",
    "return": "Zurück",
    "next": "Weiter",
    "store": "Shop",
    "type": "Typ",
    "cost": "Kosten",
    "incurred-at": "Angefallen am",
    "search-placeholder": "Suchen...",
    "more": "Mehr...",
    "load-more": "Mehr laden...",
    "status": "Status",
    "enabled": "Aktiviert",
    "disabled": "Deaktiviert",
    "total": "Gesamt",
    "un-listed": "Ungelistet",
    "global": "Global",
    "store-specific": "Shop-spezifisch",
    "ai-measurement-import": "KI-Import von Maßen",
    "included": "Inbegriffen",
    "not-included": "Nicht inbegriffen"
  },
  "snackbar": {
    "successfully-updated-your-preferences": "Ihre Präferenzen wurden erfolgreich aktualisiert",
    "failed-to-update-your-preferences": "Ihre Präferenzen konnten nicht aktualisiert werden"
  },
  "import": {
    "upload-file": "Datei hochladen",
    "sheet-import": {
      "title": "Maße aus einer Datei hochladen",
      "dropzone": {
        "title": "Datei hierher ziehen und ablegen",
        "accepted-types": "{{types}} – jeweils eine Datei",
        "browse": "Dateien durchsuchen"
      },
      "hint": "Beste Ergebnisse: eine Tabelle, deren Größenbezeichnungen den Varianten dieser Größentabelle entsprechen, mit Überschriften in der ersten Zeile oder Spalte. Fotos oder Screenshots sollten scharf und frontal aufgenommen und auf die Tabelle zugeschnitten sein.",
      "example": {
        "caption": "Beispiel für ein akzeptiertes Layout:",
        "size": "Größe",
        "chest": "Brust (cm)",
        "waist": "Taille (cm)"
      },
      "error": {
        "invalid-type": "Dieser Dateityp wird nicht unterstützt. Laden Sie eine dieser Dateien hoch: {{types}}.",
        "heic-unsupported": "HEIC-Fotos (das iPhone-Format) werden nicht unterstützt. Exportieren Sie das Foto als JPG oder PNG und laden Sie diese Datei hoch.",
        "file-too-large": "Diese Datei ist zu groß. Die maximale Größe beträgt {{maxSizeMb}} MB."
      },
      "submit": "Hochladen und Änderungen prüfen",
      "running": {
        "this-chart": "Für diese Größentabelle läuft bereits ein Import.",
        "other-chart": "Für eine andere Größentabelle läuft bereits ein Import. Es kann jeweils nur ein Import laufen.",
        "open-import": "Import anzeigen"
      },
      "accepted-files-tooltip": "Akzeptierte Dateien: {{types}}",
      "button": {
        "importing": "Import läuft… {{progress}} %",
        "review": "Import prüfen"
      }
    }
  },
  "size-recommender": {
    "form": {
      "title": "Finden Sie Ihre beste Größe",
      "subtitle": "Ein paar schnelle Details für eine bessere Passform",
      "shopping-for": "EINKAUFEN FÜR",
      "women": "Damen",
      "men": "Herren",
      "other": "Andere",
      "measurements": "MASSE",
      "height": "Größe",
      "height-required": "Größe ist erforderlich",
      "min-height": "Mindestgröße ist 1",
      "weight": "Gewicht",
      "weight-required": "Gewicht ist erforderlich",
      "min-weight": "Mindestgewicht ist 1",
      "preferred-fit": "Bevorzugte Passform"
    },
    "result": {
      "suggested-size": "Vorgeschlagene Größe:",
      "no-fit": "Leider scheinen wir derzeit keine ideale Größe zu haben. Wir empfehlen, später erneut nach weiteren Optionen zu schauen.",
      "verdict": "Ergebnis:",
      "similar-variants": "Ähnliche Varianten:",
      "proceed": "Mit dieser Variante fortfahren",
      "estimate-disclaimer": "(Schätzung basierend auf Marke und Benutzerinformationen, Ergebnisse können variieren.)"
    },
    "ai": {
      "upgrade-title": "Werten Sie Ihren Plan auf, um die KI-Größenempfehlung freizuschalten",
      "upgrade-description": "Eine Funktion, die Ihren Kunden hilft, jedes Mal die richtige Größe zu finden. Unsere KI analysiert Produktdetails und Kundeneingaben, um personalisierte Größenvorschläge zu geben, sodass Käufer mit Vertrauen kaufen und Sie weniger Retouren und Umtausche sehen. Werten Sie jetzt auf, um dieses Erlebnis in Ihrem Shop anzubieten.",
      "image-alt": "Größenempfehlung",
      "upgrade-enable": "Jetzt aufwerten und aktivieren",
      "explore-plans": "Weitere Pläne entdecken",
      "failed-load-recommendations": "Empfehlungen konnten nicht geladen werden",
      "failed-fetch-plans": "Pläne konnten nicht abgerufen werden",
      "form-tab": "Formular",
      "result-tab": "Ergebnis"
    },
    "basic": {
      "measurements-required-title": "Zuerst Maße hinzufügen",
      "measurements-required-description": "Die einfache Größenempfehlung ordnet Käufern anhand der Maße dieser Tabelle eine Größe zu. Füge der Tabelle Maße hinzu und aktiviere sie dann."
    }
  },
  "chart-limit": {
    "title-size": "Sie haben Ihr Limit für veröffentlichte Größentabellen erreicht",
    "title-table": "Sie haben Ihr Limit für veröffentlichte Rastertabellen erreicht",
    "description-size": "Mit Ihrem Plan können Sie {{limit}} Größentabellen veröffentlichen, und Sie haben {{usage}} veröffentlicht. Diese Tabelle wurde als Entwurf gespeichert. Werten Sie Ihren Plan auf, um mehr zu veröffentlichen, oder heben Sie die Veröffentlichung einer Tabelle auf, die Sie nicht mehr brauchen.",
    "description-table": "Mit Ihrem Plan können Sie {{limit}} Rastertabellen veröffentlichen, und Sie haben {{usage}} veröffentlicht. Diese Tabelle wurde als Entwurf gespeichert. Werten Sie Ihren Plan auf, um mehr zu veröffentlichen, oder heben Sie die Veröffentlichung einer Tabelle auf, die Sie nicht mehr brauchen.",
    "upgrade-plan": "Plan aufwerten",
    "explore-plans": "Pläne entdecken",
    "failed-fetch-plans": "Pläne konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
    "image-alt": "Tabellenillustration",
    "onboarding-saved-as-draft": "Ihre Tabelle wurde als Entwurf gespeichert, weil das Limit Ihres Plans für veröffentlichte Tabellen erreicht ist. Sie können sie veröffentlichen, nachdem Sie Ihren Plan aufgewertet oder die Veröffentlichung einer anderen Tabelle aufgehoben haben."
  },
  "help-centre": "Hilfecenter",
  "dimension-inputs": {
    "add-measurement": "Maß hinzufügen"
  },
  "variant-editor": {
    "option-name": "Optionsname",
    "option-values": "Optionswerte",
    "option-placeholder": "Größe / Farbe / Stoff",
    "add-option": "Weitere Option hinzufügen"
  },
  "dimension": {
    "shoulder": "Schulter",
    "bust": "Brustumfang",
    "waist": "Taille",
    "arm": "Arm",
    "sleeve": "Ärmel",
    "hip": "Hüfte",
    "crotch": "Schritt",
    "leg": "Bein",
    "thigh": "Oberschenkel",
    "length": "Länge",
    "bottom_width": "Untere Breite",
    "chest": "Brust",
    "inside_leg": "Innenbeinlänge",
    "back_length": "Rückenlänge",
    "front_length": "Vorderlänge",
    "front_rise": "Vorderer Schritt",
    "back_rise": "Hinterer Schritt",
    "leg_opening": "Beinöffnung",
    "overbust": "Oberbrust",
    "underbust": "Unterbrust",
    "groups": {
      "tops": "Oberteile",
      "bottoms": "Unterteile",
      "generals": "Allgemein"
    }
  },
  "analytic": {
    "range": {
      "1m": "1 Monat",
      "3m": "3 Monate",
      "6m": "6 Monate",
      "1y": "1 Jahr"
    }
  },
  "store-history": {
    "a-restore-is-already-running-for-this-store": "Für diesen Shop läuft bereits eine Wiederherstellung. Warte, bis sie fertig ist, und versuche es erneut.",
    "a-snapshot-is-taken-only-on-days-you-change-something": "Eine Sicherung entsteht nur an Tagen, an denen du etwas änderst.",
    "actor": {
      "merchant": "du",
      "support": "Goodchart-Support",
      "system": "Shopify"
    },
    "billing-plan-login-and-connected-integrations-are-not-touched": "Abrechnung, Tarif, Login und verbundene Integrationen bleiben unberührt.",
    "blocked": {
      "entity-exists": "Bereits neu angelegt – stattdessen wiederherstellen",
      "entity-missing": "Existiert nicht mehr – stattdessen wiederherstellen",
      "unsupported": "Nicht rückgängig zu machen – stattdessen wiederherstellen",
      "value-changed": "Seitdem geändert – stattdessen wiederherstellen"
    },
    "changes": "Änderungen",
    "discard-unsaved-changes": "Nicht gespeicherte Änderungen verwerfen?",
    "dont-ask-again-in-this-session": "In dieser Sitzung nicht mehr fragen",
    "earlier": "Früher",
    "history": "Verlauf",
    "history-starts-from-your-first-snapshot": "Der Verlauf beginnt mit deiner ersten Sicherung",
    "label": {
      "category-created": "Kategorie {{name}} erstellt",
      "category-deleted": "Kategorie {{name}} gelöscht",
      "category-updated": "Kategorie {{name}} bearbeitet",
      "chart-created": "Größentabelle {{name}} erstellt",
      "chart-deleted": "Größentabelle {{name}} gelöscht",
      "chart-updated": "Größentabelle {{name}} bearbeitet",
      "dimension-created": "Maß {{name}} erstellt",
      "dimension-deleted": "Maß {{name}} gelöscht",
      "dimension-updated": "Maß {{name}} bearbeitet",
      "draft-assignment-rules": "Zuordnungsregeln geändert",
      "draft-edited": "Tabelle bearbeitet",
      "draft-guide": "Messanleitung bearbeitet",
      "draft-labels": "Größenbezeichnungen bearbeitet",
      "draft-measurements": "Maße bearbeitet",
      "draft-model": "Modellmaße geändert",
      "draft-publication": "Veröffentlichung geändert",
      "draft-renamed": "Tabelle umbenannt",
      "draft-size-recommender": "Größenempfehlung geändert",
      "draft-variants": "Varianten bearbeitet",
      "keyword-created": "Schlagwort {{name}} erstellt",
      "keyword-deleted": "Schlagwort {{name}} gelöscht",
      "keyword-updated": "{{count}} Schlagwörter bearbeitet",
      "products-assigned": "{{count}} Produkte zugewiesen",
      "profile-updated": "Shop-Profil aktualisiert",
      "store-restored": "Shop auf {{date}} zurückgesetzt",
      "table-chart-created": "Tabelle {{name}} erstellt",
      "table-chart-deleted": "Tabelle {{name}} gelöscht",
      "table-chart-updated": "Tabelle {{name}} bearbeitet"
    },
    "no-changes-since-then": "Seitdem keine Änderungen.",
    "no-snapshots-yet": "Noch keine Sicherungen",
    "nothing-created-since-then-will-be-deleted": "Nichts, was seitdem erstellt wurde, wird gelöscht.",
    "plus-x-more": "+{{x}} weitere",
    "reloading-the-dashboard": "Dashboard wird neu geladen…",
    "restore": "Wiederherstellen",
    "restore-confirmation-word": "WIEDERHERSTELLEN",
    "restore-instead": "Stattdessen wiederherstellen",
    "restore-your-store": "Shop wiederherstellen",
    "restoring-your-store-do-not-close-this-window": "Dein Shop wird wiederhergestellt. Schließe dieses Fenster nicht.",
    "since-the-x-snapshot": "Seit der Sicherung vom {{x}}",
    "snapshots": "Sicherungen",
    "the-change-was-undone-but-the-page-could-not-refresh": "Die Änderung wurde rückgängig gemacht, aber diese Seite konnte nicht aktualisiert werden. Lade neu, um sie zu sehen.",
    "this-backup-predates-image-protection": "Diese Sicherung stammt aus der Zeit vor dem Bildschutz, daher lässt sich kein seitdem gelöschtes Bild zurückholen.",
    "this-changes-what-shoppers-see-on-your-product-pages-within-seconds": "Das ändert innerhalb von Sekunden, was Kundinnen und Kunden auf deinen Produktseiten sehen.",
    "this-changes-what-shoppers-see-right-away": "Das ändert sofort, was Kundinnen und Kunden sehen.",
    "this-puts-your-store-back-to-how-it-was-on-x": "Damit kehrt dein Shop in den Zustand vom {{x}} zurück.",
    "this-reverses-x-actions-up-to-and-including-y": "Das macht {{x}} Aktionen rückgängig, bis einschließlich „{{y}}“.",
    "trigger": {
      "daily": "Täglich",
      "install": "Bei der Installation von Goodchart",
      "manual": "Manuell (Support)",
      "migration": "Erste Sicherung",
      "pre-restore": "Vor der Wiederherstellung",
      "reinstall": "Bei der Neuinstallation von Goodchart"
    },
    "type-x-to-confirm": "Gib {{x}} ein, um zu bestätigen",
    "undid-x": "„{{x}}“ rückgängig gemacht",
    "undo-a-saved-change": "Gespeicherte Änderung rückgängig machen",
    "undo-to-here": "Bis hierher rückgängig",
    "undo-x-saved-y": "„{{x}}“ rückgängig machen, gespeichert {{y}}?",
    "unsaved": "Nicht gespeichert",
    "we-could-not-load-your-history": "Dein Verlauf konnte nicht geladen werden.",
    "we-could-not-load-your-snapshots": "Deine Sicherungen konnten nicht geladen werden.",
    "we-could-not-restore-your-store": "Dein Shop konnte nicht wiederhergestellt werden.",
    "we-could-not-work-out-what-would-change": "Es konnte nicht ermittelt werden, was sich ändern würde.",
    "we-take-a-snapshot-of-your-current-store-first-so-this-can-be-undone": "Wir sichern zuerst deinen aktuellen Shop, damit sich das rückgängig machen lässt.",
    "we-take-a-snapshot-of-your-store-each-day-it-changes": "Wir sichern deinen Shop an jedem Tag, an dem er sich ändert. Dein Verlauf erscheint hier, sobald die erste Sicherung erstellt ist.",
    "what-comes-back": "Was zurückkommt",
    "what-is-lost": "Was verloren geht",
    "working-out-what-would-change": "Es wird ermittelt, was sich ändern würde…",
    "x-assignments": "{{x}} Zuordnungen",
    "x-charts": "{{x}} Größentabellen",
    "x-images-cannot-be-brought-back": "{{x}} Bilder lassen sich nicht zurückholen – sie wurden vor mehr als 37 Tagen gelöscht.",
    "x-images-could-not-be-recovered": "{{x}} Bilder konnten nicht wiederhergestellt werden – sie wurden vor mehr als 37 Tagen gelöscht.",
    "x-items-created-since-then-will-be-deleted": "{{x}} seitdem erstellte Elemente werden gelöscht, darunter:",
    "x-items-will-be-recreated": "{{x}} Elemente werden wiederhergestellt.",
    "x-no-longer-exists-after-the-undo": "„{{x}}“ existiert nach dem Rückgängigmachen nicht mehr.",
    "x-table-charts": "{{x}} Tabellen",
    "you-have-unsaved-changes-to-x-undoing-will-discard-them": "Du hast nicht gespeicherte Änderungen an „{{x}}“. Beim Rückgängigmachen gehen sie verloren.",
    "your-store-has-been-restored": "Dein Shop wurde wiederhergestellt."
  },
  "chart-import": {
    "progress": {
      "stage": {
        "reading-file": "Ihre Datei wird gelesen",
        "understanding-table": "Tabelle wird analysiert",
        "matching-measurements": "Maße werden zugeordnet",
        "building-chart": "Ihre Größentabelle wird erstellt"
      },
      "reconnecting": "Verbindung wird wiederhergestellt – einen Moment, Ihr Fortschritt geht nicht verloren.",
      "keep-working": "Sie können weiterarbeiten — wir benachrichtigen Sie, sobald es fertig ist.",
      "cancel": "Import abbrechen",
      "cancel-confirm": {
        "title": "Diesen Import abbrechen?",
        "message": "Ihre hochgeladene Datei wird verworfen und dieser Import kann nicht fortgesetzt werden.",
        "keep": "Weiter warten",
        "discard": "Import abbrechen"
      },
      "ready": {
        "title": "Größentabelle bereit zur Prüfung",
        "action": "Änderungen prüfen"
      }
    },
    "failure": {
      "unreadable-file": {
        "message": "Das Foto war zu unscharf oder zu dunkel, um es zu lesen. Ein schärferes, gut beleuchtetes Foto funktioniert am besten."
      },
      "no-table-found": {
        "message": "In dieser Datei wurde keine Größentabelle gefunden."
      },
      "unsupported-layout": {
        "message": "Das Layout dieser Tabelle können wir noch nicht lesen."
      },
      "model-timeout": {
        "message": "Das hat zu lange gedauert – meist ist das nur ein vorübergehendes Problem."
      },
      "internal": {
        "message": "Beim Importieren Ihrer Größentabelle ist bei uns ein Fehler aufgetreten."
      },
      "action": {
        "retry": "Erneut versuchen",
        "try-another-photo": "Anderes Foto versuchen",
        "try-another-file": "Andere Datei versuchen",
        "other-methods": "Andere Methoden"
      }
    },
    "diff-review": {
      "title": "Änderungen prüfen",
      "subtitle": "Entfernen Sie das Häkchen bei allem, was nicht auf diese Größentabelle angewendet werden soll.",
      "load-error": "Die Änderungen für diesen Import konnten nicht geladen werden.",
      "no-changes": "Keine Maße wurden geändert.",
      "grid": {
        "variant": "Größe",
        "dimension": "Maß",
        "old-value": "Aktuell",
        "new-value": "Neu"
      },
      "unmatched-variants": "Größen in der Datei, die zu keiner Größe dieser Tabelle passen:",
      "unmapped-dimensions": "Spalten, die keinem Maß zugeordnet werden konnten:",
      "apply": {
        "button": "Änderungen anwenden ({{count}})",
        "success": "Größentabelle aktualisiert ({{count}} Änderungen angewendet)",
        "generic-error": "Diese Änderungen konnten nicht angewendet werden. Bitte versuchen Sie es erneut."
      },
      "cancel": {
        "button": "Import abbrechen"
      }
    },
    "review": {
      "cancel-confirm": {
        "title": "Diesen Import abbrechen?",
        "message": "Ihre hochgeladene Datei und Ihre Änderungen werden verworfen. Dieser Import kann nicht fortgesetzt werden.",
        "keep": "Weiter prüfen",
        "discard": "Import abbrechen"
      }
    },
    "page": {
      "title": "Maße importieren",
      "empty": {
        "title": "Für diese Größentabelle läuft kein Import",
        "message": "Laden Sie eine Tabellenkalkulation oder ein Foto einer Größentabelle hoch, um die Maße dieser Größentabelle zu aktualisieren."
      }
    },
    "upgrade": {
      "title": "Maße mit KI importieren",
      "description": "Laden Sie eine Tabelle oder ein Foto einer Größentabelle hoch, und wir tragen die Maße dieser Tabelle für Sie ein. Der KI-Import von Maßen ist in Ihrem aktuellen Plan nicht enthalten. Werten Sie Ihren Plan auf, um ihn zu nutzen.",
      "upgrade-plan": "Plan aufwerten",
      "explore-plans": "Pläne entdecken",
      "failed-fetch-plans": "Pläne konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
      "image-alt": "Illustration einer Größentabelle"
    }
  },
  "promotion": {
    "BlackFriday": {
      "name": "Black Friday",
      "chip": "Black-Friday-Preis",
      "popup": {
        "eyebrow": "Black Friday · Cyber Monday",
        "headline": "Bis zu {{percent}} % Rabatt",
        "subheadline": "auf Goodchart-Tarife",
        "body": "Mach deine Größentabellen fit für die geschäftigste Woche des Jahres. Klare Größen heißen weniger „Passt das?“-Fragen und weniger Retouren.",
        "feature-recommender": "KI-Größenberater, der jedem Kunden seine Größe vorschlägt",
        "feature-import": "KI-Import, der aus einer Datei oder einem Bild eine Größentabelle macht",
        "feature-analytics": "Analysen, wie Kunden deine Größentabellen nutzen",
        "cta": "Angebote ansehen",
        "later": "Vielleicht später"
      },
      "show-offer": "Black-Friday-Angebot anzeigen"
    },
    "every-plan": "{{percent}} % Rabatt auf alle Tarife",
    "up-to": "Bis zu {{percent}} % Rabatt",
    "switch-to": "Wechseln zu {{price}} $/{{interval}}",
    "switch-from": "Du hast {{name}} für {{price}} $/{{interval}}. Gleiche Funktionen, {{percent}} % günstiger.",
    "switch-note-monthly": "Shopify bittet dich, den neuen Preis zu bestätigen, und schreibt dir den Rest dieses Monats gut.",
    "switch-note-annual": "Shopify bittet dich, den neuen Preis zu bestätigen. Er gilt ab deiner Verlängerung am {{date}}.",
    "switch-note-annual-undated": "Shopify bittet dich, den neuen Preis zu bestätigen. Er gilt ab deiner nächsten Verlängerung."
  },
  "agent-chat": {
    "open": "Support-Chat öffnen",
    "close": "Support-Chat schließen",
    "expand": "Chat vergrößern",
    "collapse": "Chat verkleinern",
    "title": "Goodchart-Support",
    "history": "Unterhaltungen",
    "back": "Zurück zur Unterhaltung",
    "new": "Neue Unterhaltung",
    "placeholder": "Stelle eine Frage zu Goodchart",
    "send": "Senden",
    "welcome": "Hallo! Frag mich alles zu Goodchart: Größentabellen einrichten, den Größenratgeber in deinem Shop oder deinen Tarif.",
    "history-empty": "Noch keine Unterhaltungen.",
    "unread": "Neue Antwort",
    "you": "Du",
    "merchant": "Händler",
    "assistant": "Goodchart-Assistent",
    "team": "Goodchart-Team",
    "typing": "Schreibt…",
    "used-articles": "Aus den Hilfeartikeln beantwortet",
    "retry": "Erneut versuchen",
    "activity": {
      "articles": "Liest die Hilfeartikel…",
      "store": "Sieht sich deinen Shop an…",
      "code": "Prüft, wie Goodchart funktioniert…",
      "team": "Gibt das an das Goodchart-Team weiter…"
    },
    "error": {
      "rate-limited": "Du sendest sehr schnell Nachrichten. Versuche es in {{seconds}} Sekunden erneut. Wenn du das Goodchart-Team brauchst, frag mich danach, sobald du wieder senden kannst.",
      "daily-cap": "Du hast das heutige Nachrichtenlimit erreicht. Versuche es morgen erneut und frag mich dann nach dem Goodchart-Team, wenn du es noch brauchst.",
      "disabled": "Der Support-Assistent ist gerade nicht verfügbar.",
      "reply-failed": "Die Antwort ist nicht angekommen.",
      "unknown": "Etwas ist schiefgelaufen."
    },
    "placeholder-team": "Details für das Goodchart-Team ergänzen",
    "unavailable": "Der Support-Assistent ist gerade nicht verfügbar und nimmt keine neuen Fragen an. Unterhaltungen, die das Goodchart-Team bereits betreut, bleiben in deinem Verlauf offen.",
    "waiting": {
      "title": "Warten auf das Goodchart-Team.",
      "body": "Das Team antwortet hier und du bekommst eine Benachrichtigung. Bis dahin kannst du Details ergänzen."
    },
    "starters": {
      "create-chart": "Wie erstelle ich eine Größentabelle?",
      "no-chart": "Welche meiner Produkte haben keine Größentabelle?",
      "not-showing": "Warum wird meine Größentabelle in meinem Shop nicht angezeigt?",
      "charts-left": "Wie viele Tabellen kann ich noch veröffentlichen?"
    },
    "feedback": {
      "helpful": "Hilfreich",
      "not-helpful": "Nicht hilfreich",
      "thanks": "Danke für dein Feedback.",
      "comment-placeholder": "Was war falsch oder hat gefehlt? (optional)",
      "send": "Senden",
      "skip": "Überspringen",
      "rated-up": "Als hilfreich bewertet",
      "rated-down": "Als nicht hilfreich bewertet"
    }
  }
}
